/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-09 16:41:54
 * @LastEditTime: 2019-12-19 10:53:49
 * @LastEditTime: 2019-09-09 11:43:43
 * @LastEditors: Please set LastEditors
 */

export default {
  v5: {
    my_video_shorts: '我的影片短片',
    see_more: '查看更多',
    no_shorts_found: '找不到短片',
    shorts: '短片',
    general_information: '一般資訊',
    gamification: '遊戲化',
    click_to_select_files: '點擊選擇檔案',
    selected_files: '已選檔案',
    uploaded: '已上傳',
    failed: '失敗',
    system_will_automatically_analyze_and_select_the_most_relevant:
      '系統將自動分析並從您的組織庫中選擇最相關的文件，依據內容需求進行推薦。',
    select_from_library: ' 從資料庫中選擇',
    search_document: '搜尋文件...',
    selected: '已選擇',
    loading_documents: '正在載入文件...',
    review_generated_content: '檢視生成內容',
    confirm_and_replace_content: '確認並替換內容',
    the_generate_content_will_replace:
      '生成的內容將取代所選頁面上的現有文本。如果不想套用這些更改，您可以返回上一步。',
    pages_to_be_updated: '將更新的頁面',
    generated_revisions: '已生成的修訂',
    lesson_preview: '課程預覽',
    create_new_folder: '建立新資料夾',
    rename_item: '重新命名項目',
    enter_folder_name: '輸入資料夾名稱:',
    enter_new_name: '輸入新名稱:',
    folder_name: '資料夾名稱:',
    new_name: '新名稱',
    move_items: '移動項目',
    copy_items: '複製項目',
    move_here: '移到這裡',
    copy_here: '複製到這裡',
    select_destination_library_and_folder: '選擇目標資料庫和資料夾:',
    items_selected: '已選項目',
    version: '版本',
    modified_by: '修改者',
    size: '大小',
    restore: '還原',
    are_you_sure_you_want_to_restore_this_version: '您確定要還原此版本嗎？',
    this_will_replce_the_current_version_with_the_selected_one:
      '這將用所選版本取代目前版本。',
    restore_this_version: '還原此版本',
    restore_not_available: '無法還原',
    version_history: '版本歷史:',
    by_making_items_public:
      '將項目設為公開後，所有人皆可查看。請在繼續前閱讀條款與細則。',
    the_selected_items_will_be_copied:
      '所選項目將複製到您的公開庫，並對所有人可見。',
    the_selected_items_will_be_copied_to_org:
      '所選項目將複製到組織庫，並對所有組織成員可見。',
    the_selected_items_will_be_copied_to_your_private:
      '所選項目將複製到您的私人庫，只對您可見。',
    loading_organization: '正在載入組織使用者...',
    click_download_to_view: '點擊下載以檢視',
    archive_file: '檔案歸檔',
    no_preview_available: '無法預覽',
    audit_report: '稽核報告',
    audit_type: '操作類型',
    i_agree_to_the_terms_and_conditions: '我同意條款與細則。',
    this_file_is_indexed_for_ai: '此檔案已為 AI 建立索引。',
    file_is_not_indexed_for_ai: '此檔案未為 AI 建立索引。',
    no_users_found: '找不到使用者',
    no_users_available: '無可用使用者',
    add_people: '新增使用者',
    people: '使用者',
    access_type: '存取類型',
    no_group_found: '找不到群組',
    add_group: '新增群組',
    groups: '群組',
    users_top: '使用者',
    confirm_delete: '確認刪除',
    do_you_want_remove: '您確定要移除嗎',
    form_this_documents_permissions: '從此文件的權限中？',
    no_users_found_in_this_group: '此群組中找不到使用者',
    add_selected_users: '新增已選使用者',
    choose_users_from_the_list: '從列表中選擇使用者',
    selected_users: '已選使用者',
    archived: '已歸檔',
    request_approval: '請求批准',
    document_in_review: '文件審核中',
    approve: '批准',
    reject: '拒絕',
    comment: '評論:',
    enter_your_commit: '輸入您的評論...',
    confirm_cancel: '確認取消',
    upload_3d_zip: '上傳 3D 壓縮檔',
    delete_items: '刪除項目',
    video_upload_request: '影片上傳請求',
    reject_video: '拒絕影片',
    enter_rejection_reason: '輸入拒絕原因...',
    please_provide_a_reason_for_reejection_this_video:
      '請提供拒絕此影片的原因：',
    generate_trivia_with_ai: '使用 AI 生成問答',
    select_category: '選擇分類:',
    number_of_question: '問題數量',
    generated_questions: '已生成問題',
    this_will_clear_all_generate_question: '這將清除所有生成的問題，是否繼續？',
    sure_delete: '您確定要刪除嗎？',
    delete_this_question: '您確定要刪除此問題嗎？',
    loading_quiz: '正在載入測驗...',
    creteing_file: '正在建立檔案',
    opening_desktop_app: '正在開啟桌面應用程式',
    this_folder_is_empty: '此資料夾為空',
    select_a_competition: '選擇比賽...',
    activity_badges: '活動徽章',
    awarded_every_badges: '每 4, 8, 16, 32, 64, 128, 256, 512 次登入獲得',
    learning_badges: '學習徽章',
    awarded_every_courses: '每完成 1, 4, 8, 16, 32, 64, 128 課程獲得',
    test_badges: '測驗徽章',
    awarded_every_passes_tests: '每通過 2, 4, 8, 16, 32, 64, 128, 256 測驗獲得',
    assignment_badges: '作業徽章',
    awarded_every_passed_assignments:
      '每完成 1, 2, 4, 8, 16, 32, 64, 128 作業獲得',
    perfectionism_badges: '完美主義徽章',
    awarded_every_assignments_with_scrore:
      '每次測驗或作業得分 90%+ 獲得 1, 2, 4, 8, 16, 32, 64, 128',
    communication_badges: '溝通徽章',
    awarded_every_topics_or_comments:
      '每 2, 4, 8, 16, 32, 64, 128, 256 主題或評論獲得',
    certification_badges: '認證徽章',
    awarded_every_certificates: '每 1, 2, 4, 8, 16, 32, 64, 128 證書獲得',
    level_name: '等級名稱',
    delete_competition: '刪除比賽',
    this_week: '本週',
    this_year: '今年',
    make_organization: '建立組織',
    no_results_found: '未找到結果',
    no_items_available: '無可用項目',
    help_video: '教學影片',
    select_a_video_from_the_list: '從列表中選擇影片開始學習'
  },
  v4: {
    drop_files: '拖放檔案並選擇上傳位置。',
    duplicate_lessoon: '課程中已存在該課程內容',
    skill_rule_title: '請輸入技能學習路徑標題',
    imageCreatorTitle: '圖像創建器',
    isTranslated: '已翻譯',
    translationCourseDesc: '課程翻譯可能需要幾分鐘，感謝您的耐心等待！',
    translateCourseTip:
      '建立一個可獨立於原始內容修改的翻譯課程，包括所有課程單元與頁面。',
    translateModalBtn: '翻譯',
    translationSuccess: '課程「<0/>」已成功翻譯！',
    translatingCourse: '正在翻譯課程...',
    translateModalTitle: '翻譯課程',
    translateSelectLang: '選擇語言',
    fileDeleteconfirm: '您確定要刪除此檔案嗎？此操作無法復原。',
    fileDeleteMessage: '檔案已成功刪除。',
    fileDeleteFailedMessage: '檔案刪除失敗！',
    fileDelete: '刪除此檔案。',
    certificate_save_btn: '新增證書至 ',
    maze_path_info: '圖形中無可用路徑！',
    file_size_mb: '檔案大小必須小於 25 MB！',
    reports: {
      products: '產品',
      users: '使用者',
      ph_username: '以使用者名稱搜尋',
      ph_id: '以使用者 ID 搜尋',
      ph_email: '以使用者電子郵件搜尋'
    },
    select_upload_section_id: '必須選擇章節上傳檔案',
    tags_all: '全部',
    delete_file_confirm: '您確定要刪除此檔案？',
    delete_file_title: '刪除檔案',
    tooltip_publish: '在所選選項中發佈課程',
    tooltip_save: '儲存課程並更新當前內容',
    tooltip_next: '前往下一步課程設定',
    tooltip_finish: '完成並儲存目前更新',
    stories_modal: {
      title_upload: '上傳故事',
      title_update: '更新故事',
      title_audio: '故事音訊檔案',
      btn_upload: '上傳',
      btn_update: '更新',
      btn_close: '關閉',
      btn_cancel: '取消',
      lbl_cover: '故事封面圖片',
      rule_cover: '請上傳故事音訊封面！',
      lbl_title: '故事音訊標題',
      rule_title: '請輸入故事音訊標題！',
      lbl_description: '故事音訊描述',
      rule_description: '請輸入故事音訊描述！',
      lbl_file: '上傳故事音訊檔案',
      rule_file: '請上傳故事音訊檔案！',
      rule_file_type: '請上傳有效的音訊檔案！',
      lbl_select_file: '選擇故事音訊檔案',
      msg_valid_file: '請選擇有效的故事音訊檔案！',
      msg_success: '故事音訊檔案上傳成功',
      msg_failed: '媒體資料指派失敗！',
      msg_error: '上傳檔案發生錯誤！'
    },
    audio_modal: {
      title_upload: '上傳',
      title_update: '更新',
      title_audio: '音訊檔案',
      btn_upload: '上傳',
      btn_update: '更新',
      btn_close: '關閉',
      btn_cancel: '取消',
      lbl_cover: '音訊封面',
      rule_cover: '請上傳音訊封面！',
      lbl_title: '音訊標題',
      rule_title: '請輸入音訊標題！',
      lbl_description: '音訊描述',
      rule_description: '請輸入音訊描述！',
      lbl_file: '上傳音訊檔案',
      rule_file: '請上傳音訊檔案！',
      rule_file_type: '請上傳有效的音訊檔案！',
      lbl_select_file: '選擇音訊檔案',
      msg_valid_file: '請選擇有效的音訊檔案！',
      msg_success: '音訊檔案上傳成功',
      msg_failed: '媒體資料指派失敗！',
      msg_error: '上傳檔案發生錯誤！'
    },
    info_episode: '單集的封面圖片。',
    btn_delete_episode: '刪除此 Podcast 單集。',
    btn_edit_marketplace: '編輯市集詳情。',
    btn_save_marketplace: '儲存當前變更。',
    btn_ai_podcast: '建立 AI 驅動的 Podcast 單集。',
    btn_upload_podcast: '上傳您自己的 Podcast 音訊單集。',
    attach_file: '上傳檔案以與觀眾分享更多內容',
    fileDownload: '下載此檔案。',
    singleEpishode: '單集',
    podcast_music: 'Podcast、音樂與故事',
    publishHeader: '發佈 Podcast、音樂與故事',
    editHeader: '編輯 Podcast、音樂與故事',
    createHeader: '建立 Podcast、音樂與故事',
    marketplaceHeader: 'Podcast、音樂與故事市集詳情',
    message_marketplace: '請完成市集表單！',
    create_podcast_live: '現場 Podcast 與音樂',
    create_podcast_custom: '自訂 Podcast 與音樂',
    create_podcast_stories: '故事',
    ai_Assisted_podcast_reation: 'AI 協助 Podcast 與音樂創作',
    publishTitle: '公開發佈 Podcast、音樂與故事內容。',
    customButton: '建立自訂內容',
    customTitle: '儲存對 Podcast 的變更。',
    updateButton: '更新',
    createButton: '建立',
    createNewButton: '建立新內容',
    updateTitle: '更新目前的 Podcast、音樂與故事詳情。',
    createTitle: '建立新的 Podcast、音樂與故事',
    createNewTitle: '將以目前的 Podcast、音樂與故事為基礎建立新內容。',
    podcastTitle: '單集列表',
    podcastStoryTitle: '故事單集列表',
    podcastToolTipTitle: 'Podcast 單集清單',
    uploadAudio: '上傳',
    aiAudio: 'AI 音訊',
    emptyPodcast: '尚未錄製任何 Podcast、音樂或故事音訊。',
    emptyStoriesPodcast: '尚未新增任何故事。',
    emptyCreatePodcast: '請先建立 Podcast 才能新增音訊內容。',
    playPodcast: '播放所選 Podcast、音樂與故事。',
    pausePodcast: '暫停所選 Podcast、音樂與故事。',
    selectPodcast: '選擇此 Podcast、音樂與故事。',
    downloadPodcast: '下載此音訊。',
    uploadAudioFile: '上傳新音訊並取代當前音訊。',
    deleteConfirm: '您確定要刪除此音訊嗎？',
    roomName: 'Podcast 名稱',
    addGuestTitle: '新增來賓講者',
    showTime: '播放時間',
    startTime: '開始時間',
    endTime: '結束時間',
    erorMsgImg: '請選擇有效圖片。',
    failedMsgImg: '圖片載入失敗，請重試！',
    failedMsgUpload: '上傳封面圖片失敗！',
    btnCoverUpload: '上傳封面',
    is_private: '私人',
    to_attach: '附加檔案',
    file_attached: '已附加檔案',
    main_event: '主要活動',
    event: '活動',
    upload_pdf: '上傳 PDF',
    portrait: '直式',
    landscape: '橫式',
    import_from_library: '從媒體庫匯入文字',
    question_answer_ai: '問答 AI',
    take_maze: '開始 MetaMaze',
    training: '訓練',
    select_transcribe_locale: '選擇轉錄語言',
    transcribe_limit: '請輸入要轉錄的分鐘數',
    not_complete: '市場資訊不完整',
    complete: '市場資訊完整',
    not_admin: '需要管理員權限才能發佈到市場',
    no_course: '請輸入標題並選擇圖片以啟用市場',
    scorm_not_complete: '請輸入標題並選擇圖片以上傳 SCORM 檔案',
    not_found_maze: '找不到 MetaMaze',
    email_require: '需要電子郵件',
    poll_required: '需要評估資料',
    alert: '提醒！',
    warning: '警告！',
    ok: '確定',
    cancel: '取消',
    done: '完成',
    insert: '插入',
    private: '私人',
    public: '公開',
    no_connection: '無網路連線',
    switch: '切換',
    share_screen: '分享螢幕',
    stop_share_screen: '停止分享螢幕',
    share_screen_with_camera: '分享螢幕與鏡頭',
    stop_share_screen_with_camera: '停止分享螢幕與鏡頭',
    camera_on: '開啟鏡頭',
    camera_off: '關閉鏡頭',
    mic_on: '開啟麥克風',
    mic_off: '關閉麥克風',
    fullscreen: '全螢幕',
    live_now: '正在直播',
    schedule_on: '排程日期：',
    organisations: '組織',
    org_groups: '組織群組',
    specific_user: '指定使用者',
    gif: 'GIF',
    unavailable: '無法使用',
    yes: '是',
    no: '否',
    event_duration_message: '最長 300 分鐘（5 小時）',
    send_email: '發送電子郵件通知',
    admin_only: '僅限管理員',
    join: '加入',
    leave: '離開',
    share: '分享',
    share_text: '請輸入您想分享此檔案的對象電子郵件地址。',
    share_text_title: '分享 PDF',
    share_text_title_txt: '分享文字',
    select_users: '選擇使用者',
    delete: '刪除',
    attachment_event: '活動附件：',
    transcribe_limit: '轉錄限制分鐘數',
    monthly_transcribe: '每月轉錄上限：',
    enable_ai: '啟用 AI：',
    enable_maze: '啟用 MetaMaze：',
    media_service: '媒體服務',
    allow_others: '允許他人編輯',
    join_breakout_room: '加入分組討論室',
    bio: '簡介',
    linkedin: 'LinkedIn',
    select_org_report: '請搜尋並選擇組織以建立報告。',
    org_image_not_found: '找不到圖片',
    insert_text: '插入文字',
    insert_question_answer: '問答 AI',
    modal_title2: '文字內容庫',
    my_text_library: '我的文字庫',
    ai: 'AI',
    public_text_library: '公開文字庫',
    organization_text_library: '組織文字庫',
    no_transcribed_text: '尚無轉錄文字',
    public_text_not_found: '找不到公開轉錄文字',
    org_text_not_found: '找不到組織轉錄文字',
    org_video_not_found: '找不到影片',
    canva: '在 Canva 中建立',
    canva_open: '點此開啟 Canva 編輯器。',
    pdf: 'PDF',
    txt: '文字',
    human: '進階',
    shared_file: '您的檔案已成功分享。',
    error_shared_file: '檔案分享時發生問題，請再試一次。',
    publish: '發佈',
    maze_scenes: 'MetaMaze 場景',
    pexel_images: 'Pexel 圖片',
    group: '群組',
    group_name: '群組名稱',
    select_group: '選擇群組',
    search_maze: '搜尋 MetaMaze',
    hosts: '主持人',
    avg_score: '平均得分',
    maze_report: 'Maze 報告',
    maze_view: 'Maze 檢視',
    title_maze: 'MetaMaze',
    author: '作者',
    match: '匹配路徑',
    preview_mazeTitle: '標題：',
    other: '其他',
    total: '總計',
    report_course: '課程',
    report_courses: '課程',
    report_event: '活動',
    report_events: '活動',
    report_maze: 'MAZE',
    report_personalize_learning: '個人化學習',
    report_live_assessment: '即時評估',
    report_live_assessments: '即時評估',
    report_skill_journey: '技能旅程',
    skill_journey: '技能旅程',
    skill_journeys: '技能旅程',
    date: '日期：',
    search_people: '搜尋人員',
    passed: '通過',
    failed: '未通過',
    item: '項目',
    type: '類型',
    minimum_pass_score: '最低通過分數',
    resources_count: '資源數量',
    back: '返回',
    resources: '資源',
    time_spent: '花費時間（分鐘）',
    detail: '詳情',
    watched_time_mins: '觀看時間（分鐘）',
    personalize_learning: '個人化學習',
    result: '結果',
    assessment_title: '標題',
    marketPlace_graph: '市場圖表',
    attachments: '附加檔案',
    new_scorm_course: '上傳新的 SCORM 課程',
    upload_scorm_course: '上傳 SCORM 課程',
    new_maze: '建立新的 MetaMaze',
    new_skill_journey: '建立技能旅程',
    tags_scorm: 'SCORM',
    tags_skillJourney: '技能旅程',
    new_discussion_room: '建立新的 Podcast',
    title: '您今天想做什麼？',
    build_course: '建立我的課程',
    live_broadcast: '直播',
    invite_users: '邀請使用者加入我的組織',
    build_voice_over: '建立我的旁白',
    view_reports: '查看報告',
    upload_media: '上傳我的媒體或作品並分享',
    main_menu: '主選單',
    get_started: '開始使用',
    search_group: '搜尋組織群組',
    ai_course: 'AI 課程',
    search_user: '搜尋公司名稱',
    no_maze: '目前沒有 MetaMaze。',
    conference_event_title: '會議活動',
    conference_event_subTitle: '已結束的會議活動',
    conference_event: '目前沒有會議活動。',
    no_skill: '目前沒有技能旅程。',
    no_podcast: '目前沒有 Podcast。',
    maze_channel: 'MetaMaze',
    past_live_assessment: '過往的即時評估',
    no_live_assessment: '目前沒有即時評估。',
    enrolled_courses: '課程',
    my_video_channel: '我的影片頻道',
    enrolled_liveEvents: '即時活動',
    sharebot: 'Sharebot',
    selected_language: '選擇的語言',
    shareSphere_game: 'ShareSphere 遊戲',
    maze: 'MetaMaze',
    skill: '技能旅程',
    channel: '頻道',
    order: '順序',
    is_record: '錄製',
    no_maze_found: '找不到 MetaMaze。',
    maze_self_limit_reached: '已達到 MetaMaze 自我評估次數上限。',
    metamaze_two_times: '您已經進行此 MetaMaze 兩次。',
    metamaze_two_times_no_result:
      '您已經進行此 MetaMaze 兩次。完成第三次將不會記錄您的結果。',
    scorm_zip: 'SCORM ZIP',
    pass_score: '通過的最低分數',
    organization: '請選擇一個組織',
    pass_score_mark: '請輸入 1 到 100 之間的分數',
    maze_cloning_success: 'MetaMaze "<0/>" 已成功複製！',
    create_certificate: '建立證書',
    create_badge: '建立徽章',
    certificate_added: '已新增證書。',
    badge_added: '已新增徽章。',
    certificate_warning: '一旦證書／徽章已發佈，將無法再編輯！',
    created_course_plan: '編輯並發佈您建立的課程，並安排即時活動',
    market_place_space: '市集空間',
    select_course_language: '選擇語言（可選）',
    select_language: '選擇語言',
    file_upload: '上傳檔案',
    text: '在此輸入文字…',
    attempts_count: '使用者可重試的次數',
    no_of_people_placeholder: '人數',
    back_to_maze: '返回 MetaMaze 情境',
    edit_maze: '編輯 Maze',
    wait: '請稍候...',
    retry: '重試',
    publish_scorm_course: '發佈您的 SCORM 課程',
    publish_maze: '發佈您的 MetaMaze',
    import: '匯入元素',
    answer_correct: '請選擇正確答案',
    author_name: '請輸入作者姓名',
    select_category: '請選擇一個類別',
    course_outline: '請輸入課程大綱',
    course_obj: '請輸入課程目標',
    course_description: '請輸入課程描述',
    maze_outline: '請輸入迷宮大綱',
    maze_obj: '請輸入迷宮目標',
    maze_description: '請輸入迷宮描述',
    lessons: '請輸入課程數量',
    user_email_require: '使用者電子郵件為必填',
    team_size: '請輸入團隊人數',
    enter_price: '請輸入價格（5元或以上）',
    input_title_maze: '請輸入迷宮標題',
    trainer_bio: '請輸入講師簡介',
    trainer_linkedin: '請輸入講師的 LinkedIn 連結',
    error_video: '請輸入影片數量',
    input_video_link: '請輸入影片連結',
    number_of_video: '影片數量',
    number_of_lessions: '課程數量',
    no_of_people_in_conference: '會議中有多少人？',
    transcribe_settings: '轉錄設定',
    transcribe: '轉錄',
    cloning_maze: '正在複製 MetaMaze...',
    id_number: '身份證號碼',
    timezone: '時區',
    edit_maze: '編輯',
    delete_maze: '刪除',
    view_maze: '檢視',
    create_metamaze: '建立 MetaMaze',
    metamaze_scenario: 'MetaMaze 情境',
    publish_metamaze: '發布設定',
    search_result: '搜尋結果：',
    search_for: '搜尋關鍵字',
    search_no_result: '- 沒有可用的結果！',
    channel_no_available: '沒有可用的頻道！',
    this_card: '這是一張卡片',
    course_no_available: '沒有可用的課程！',
    exit_fullscreen: '退出全螢幕',
    bg_image: '背景圖片',
    introduction: '介紹',
    summary: '摘要',
    generate_introduction: '產生介紹',
    generate_summary: '產生摘要',
    bullet_points: '重點項目',
    title_simulation: '請輸入模擬名稱',
    view_generated_images: '檢視已產生的圖片',
    image_transparency: '圖片透明度',
    template_bg_color: '模板背景顏色',
    select_template_layout: '選擇模板佈局',
    reload_template: '(重新載入模板)',
    are_you_sure_want_close: '您確定要關閉嗎？',
    all_your_changes_will_be_lost: '您所有的變更將會遺失。',
    please_checked_before_generated_video: '請確認所有條件已勾選後再產生影片。',
    voice_must_be_selected: '必須選擇一個語音',
    avatar_must_be_selected: '必須選擇一個頭像圖片',
    maximum_five_slides_try_again:
      '從檔案擷取圖片時發生錯誤。請確認您的簡報檔最多只有 5 張投影片，且每張都有備註。請再試一次！',
    back_to_upload: '返回上傳',
    uploading_file_to_server: '正在將檔案上傳至伺服器',
    extracting_images_from_your_file: '正在從您的檔案中擷取圖片',
    upload_your_ppt_or_drag: '上傳您的簡報檔案（.PPTX）或拖曳至此。',
    maximum_five_slides_error:
      '請確保您的 PowerPoint 檔案最多包含 5 張投影片，且每張都有備註，否則會產生錯誤。',
    number_of_questions_generated: '要產生的題目數量',
    quiz_page_this_cannot_be_done:
      '您確定要在此頁面新增測驗嗎？此操作無法還原。',
    confirm_selection: '確認選擇',
    select_quiz_page: '選擇測驗頁面',
    lesson_do_you_want_add_this_quiz: '您希望將此測驗新增至課程的哪一部分？',
    beginning_of_lesson: '課程開始處',
    end_of_lesson: '課程結束處',
    currently_active_page: '目前正在使用的頁面',
    finish: '完成',
    upload_selection_file: '上傳區段檔案',
    general_quiz: '一般測驗',
    manage_sequence: '管理順序',
    save_sequence: '儲存順序',
    new: '新的',
    in_progress: '進行中',
    recommended_course: '推薦課程',
    up_coming: '即將推出',
    past_live: '過去的直播',
    input_your_channel_name: '請輸入您的頻道名稱！',
    organization_place: '組織市集',
    marketplace_report: '市集報告',
    story_writing: '故事寫作',
    Ai_quiz: 'AI 測驗',
    generate_quiz: '產生測驗',
    create_story: '創建故事',
    change_layout_page: '您即將更改此頁面的佈局。',
    change_layout_message:
      '請注意，只有文字、圖片、背景和標誌會保留。所有其他元素將從頁面中移除。',
    reviews: '評價',
    tab_attachments: '附件',
    zoom_in: '放大',
    zoom_out: '縮小',
    zoom_reset: '重設縮放',
    no_attachment: '沒有附件。',
    select_upload_simulation: '請選擇或上傳模擬內容。',
    quiz_updated_successfully: '測驗更新成功！',
    quizes: '測驗',
    trivia: '趣味問答',
    closing: '正在關閉...',
    products: '產品',
    ask_questions: '請在此輸入問題...',
    course_information: '課程資訊',
    course_assistance: '課程建立協助',
    go_back: '返回',
    ai_generate_content_progress: 'AI 正在產生內容中',
    view_generate_content: '檢視產生的內容',
    generate_error: '產生錯誤！',
    confirm_creating_course: '您是否要確認使用這些內容建立課程？',
    generate_content_automatically:
      '這將自動將所有產生的內容新增為課程中的課程與頁面。',
    quiz_created_successfully: '測驗建立成功！',
    create_quiz: '建立測驗',
    quiz_setting: '測驗設定',
    please_fill_quiz_setting: '* 請填寫測驗設定中的所有欄位',
    question_list: '問題清單',
    add_quiz_to_page: '將測驗新增至頁面',
    form_create_question: '建立問題表單',
    user_information_updated: '使用者資訊已更新！',
    your_stripe_activete_to_continue:
      '您的 Stripe 帳戶未啟用。請連接或啟用以繼續。',
    connect_tripe: '連接 Stripe',
    certificate_sent_sucessfully: '證書已成功寄送至您的電子郵件。',
    error_try_again: '發生錯誤，請再試一次！',
    error_delete_channel: '刪除頻道時發生錯誤。',
    error_update_sub: '更新訂閱時發生錯誤。',
    end_time_cannot_start: '結束時間不能早於開始時間。',
    start_date_time_interval: '開始日期與時間區間為必填！',
    podcast_updated_successful: 'Podcast 更新成功。',
    podcast_created_successful: 'Podcast 建立成功。',
    podcast_published_successful: 'Podcast 已成功發佈。',
    podcast_cover_updated: 'Podcast 封面已更新',
    new_podcast_details: '將以新的輸入細節建立新的 Podcast。',
    current_update_podcast: '更新目前 Podcast、音樂與故事內容。',
    create_new_podcast: '建立新的 Podcast',
    publish_podcast_public_view: '將 Podcast 發佈為公開狀態。',
    only_allowed_twenty_five_email: '最多僅允許 25 個電子郵件',
    only_allowed_five_email: '最多僅允許 5 個電子郵件。',
    cover_is_required: '封面為必填。',
    topic_is_required: '主題為必填。',
    delete_schedule: '刪除排程',
    make_as_coaching: '標記為可預約輔導',
    manage_category: '管理類別',
    threshold: '門檻',
    threshold_popup: '百分比 (%) 門檻值，達到後將啟用推薦功能於此類別。',
    list_of_catagory: '類別清單',
    category_name: '類別名稱',
    category_threshold: '類別門檻',
    play_game: '玩遊戲',
    switching_organization: '正在切換組織...',
    coaching_session: '輔導課程',
    required_channel_id: '必須提供頻道 ID！',
    error_occured_try_again: '發生錯誤，請再試一次！',
    please_complete_marketplace_form: '請完成 Marketplace 表單！',
    upload_file_corrupt: '上傳的檔案已損毀。',
    course_not_published: '課程尚未發佈！',
    error_request: '請求發生錯誤，請再試一次！',
    skill_request: '請填寫所有缺少的欄位！',
    error_occured: '發生錯誤，請再試一次！',
    show_time: '顯示時間',
    start_time: '開始時間',
    end_time: '結束時間',
    room_name: 'Podcast 名稱',
    add_guest_speaker: '新增來賓講者',
    cover_picture: '封面圖片',
    guest_speaker: '來賓講者',
    see_more: '查看更多',
    see_less: '收合',
    background: '背景',
    icon: '圖示',
    icon_size: '圖示大小',
    icon_color: '圖示顏色',
    only_text: '僅文字',
    change_bg: '變更背景顏色',
    bg_color: '背景顏色',
    font_size: '字體大小',
    normal: '一般',
    change_color: '變更文字顏色',
    slant_text: '斜體文字',
    text_radius: '文字圓角',
    vertical_align: '垂直對齊',
    horizontal_align: '水平對齊',
    change_icon_color: '變更圖示顏色',
    upload_icon: '上傳圖示',
    upload_signature: '上傳簽名',
    add_another_sign: '新增另一個簽名',
    name_badges: '徽章名稱',
    should_less_150: '應少於 150 個字元',
    your_badge: '您的徽章',
    do_you_want_delete_badge: '您確定要刪除此徽章嗎？',
    do_you_want_delete_cert: '您確定要刪除此證書嗎？',
    upload_logo: '上傳標誌',
    name_of_cert: '證書名稱',
    upload_cert: '更新證書',
    your_cert: '您的證書',
    translate_to: '翻譯成',
    select_file_attach: '選擇要附加的檔案',
    certificate: '證書',
    badge: '徽章',
    publish_options: '發佈選項',
    publish_skills_journey: '發佈技能旅程',
    videos: '影片',
    generate_ai_video:
      '影片產生過程可能需要一些時間，完成後將以電子郵件通知您。',
    trainer_information: '講師資訊',
    promotional_video_link: '宣傳影片連結',
    please_select: '請選擇',
    image_name: '圖片名稱：',
    image_size: '圖片大小：',
    charecters_fifteen_less: '15 個字元以內',
    leadership: '領導力',
    text_arc: '文字弧度',
    vertical: '垂直',
    horizontal: '水平',
    badge_history: '徽章記錄',
    templates: '樣板',
    sign: '簽名',
    logo: '標誌',
    certificate_history: '證書記錄',
    please_wait: '請稍候...',
    information: '資訊',
    support_five_thousand_live_event: '支援最多 5000 人的現場活動',
    support_ten_live_event: '支援最多 10 位現場視訊參與者',
    we_will_back_participant: '我們將以更多參與者回歸活動',
    course_objectives: '課程目標',
    course_outlines: '課程大綱',
    price_dollor: '價格（美元）',
    not_completed: '尚未完成',
    enable_marketplace: '啟用 Marketplace',
    enable_course_ai: '啟用 AI 課程建立',
    enable_report_to_admin: '啟用報告給管理員',
    enable_white_label: '啟用白標品牌',
    enable_eleven_labs_for_maze_play: '啟用 Elevenlabs 於迷宮互動中',
    enable_eleven_labs_for_maze_play_cloned: '啟用 Elevenlabs 複製聲音',
    simulation_quiz: '模擬測驗',
    bg_color_setting: '背景色設定',
    color_preview: '顏色預覽',
    choose_new_color: '選擇新顏色',
    remove_color: '移除顏色',
    apply_color: '套用顏色',
    elemeent_in_a_sceenario_page:
      '無法在情境頁面中新增其他元件，請嘗試其他頁面或先移除情境內容。',
    no_data_found: '查無資料。',
    references: '參考資料',
    open_file: '開啟檔案',
    showing_result: '顯示結果：',
    fiften_day_free_trail: '15 天免費試用',
    your_browser_does_not_support: '您的瀏覽器不支援此音訊元件。',
    podcast_desc: 'Podcast 描述',
    input_podcast_desc: '請輸入 Podcast 描述',
    podcast_obj: 'Podcast 目標',
    input_podcast_obj: '請輸入 Podcast 目標',
    podcast_outline: 'Podcast 大綱',
    input_podcast_outline: '請輸入 Podcast 大綱',
    add_file: '新增檔案',
    generate_podcast_audio: '產生 Podcast 音訊',
    generate_uploaded_file_input_parameter:
      '根據使用者上傳的檔案與輸入參數生成內容。',
    go_backe_generation_state: '返回內容生成狀態。',
    create_ai_powered_podcast: '建立 AI 驅動的 Podcast 集數與音訊。',
    generate_voice_for_all_podcast: '請為所有 Podcast 集數生成語音',
    create_podcast_episode: '建立 Podcast 集數',
    voice_name: '語音名稱',
    input_custom_name: '請輸入自訂名稱！',
    enter_custom_name: '輸入自訂語音名稱',
    upload_complete: '上傳完成',
    uploading_in_progress: '正在上傳中...',
    podcast_stream_content: 'Podcast 串流內容',
    upload_podcast_cover: '請上傳 Podcast 封面！',
    enter_podcast_name: '請輸入 Podcast 名稱！',
    podcast_topic: 'Podcast 主題',
    enter_podcast_topic: '請輸入 Podcast 主題！',
    enter_podcast_desc: '請輸入 Podcast 描述！',
    number_of_speaker: '說話者人數',
    select_the_number_of_speaker: '請選擇說話者人數！',
    number_of_episode: '集數',
    input_number_of_episode: '請輸入集數！',
    podcast_length: 'Podcast 長度',
    select_the_podcast_length: '請選擇 Podcast 長度！',
    short_podcast: '短（5-10 分鐘）',
    medium_podcast: '中（15-18 分鐘）',
    long_podcast: '長（18 分鐘以上）',
    name_of_host: '主持人姓名',
    enter_host_name: '請輸入主持人姓名！',
    guest_name: '來賓姓名',
    enter_guest_name: '請輸入來賓姓名！',
    choose_speaker_tone: '選擇說話語氣',
    enter_speaker_tone: '請選擇 Podcast 語氣！',
    informal: '非正式',
    formal: '正式',
    serious: '嚴肅',
    light_humor: '輕鬆幽默',
    casual: '隨性',
    select_content_source: '選擇內容來源',
    from_internet: '來自網路',
    upload_pdf_internet: '上傳 PDF 或內部文件',
    note: '注意：',
    podcast_content_will_be_automatically_generated:
      'Podcast 內容將會自動從可信的網路資源中生成。',
    upload_or_select_file: '請上傳或選擇檔案！',
    podcast_eposode_title: 'Podcast 集數標題',
    enter_podcast_title: '請輸入集數標題！',
    podcast_episode_des: 'Podcast 集數描述',
    enter_podcast_episode_des: '請輸入集數描述！',
    voice: '語音',
    music: '音樂',
    select_music: '選擇音樂',
    play_the_music: '播放音樂',
    stop_the_music: '停止音樂',
    context: '內容背景',
    generate_audio_content_selected_voice: '將根據所選語音生成內容音訊。',
    required_field_before_submitting: '提交前請填寫所有必填欄位。',
    regenerate_voice: '重新生成語音',
    generate_voice: '生成語音',
    your_browser_does_not_suppot: '您的瀏覽器不支援音訊元素。',
    are_sure_leave_podcast: '確定要離開 Podcast 嗎？',
    broadcast_ongoing: '直播進行中。您真的要離開此頁面嗎？',
    brodcaster_unavailable: '目前主持人無法使用。',
    setting_calender_for_booking: '正在設定預約日曆',
    add_calender: '新增日曆',
    waiting_join_host: '等待主持人加入中...',
    no_reviews_found: '找不到評論。',
    rated_already: '您已評分此直播活動。',
    downlink_png: '下載 PNG',
    downlink_jpg: '下載 JPG',
    donwload_file_format: '請選擇要下載的檔案格式。',
    crashed_event: '此活動已崩潰。請建立新活動。造成不便，敬請見諒。',
    prompt: '提示：',
    generated_image: '🚀 正在產生圖像...請稍候。',
    download_add: '全部下載',
    setting_generator: '設定生成器',
    enter_image_prompt: '請輸入圖像提示',
    image_prompt: '輸入圖像提示',
    negative_prompt: '負面提示',
    negative_image_prompt: '輸入負面圖像提示',
    number_output: '輸出數量',
    enter_number_output: '請輸入輸出數量',
    image_style: '請選擇圖像風格',
    output_format: '輸出格式',
    seeds: '種子',
    enter_seeds: '請輸入種子數',
    performance_mode: '效能模式',
    quality: '品質',
    speed: '速度',
    balanced: '平衡',
    guidance_scale: '指導尺度',
    enter_guidance: '請輸入指導尺度',
    select_image: '請選擇圖像。',
    image_prmt: '圖像提示',
    generate_image_list_empty: '生成圖像清單為空。',
    knowledge_center_tooltrip_des:
      '獲得清晰且具上下文相關性的回應，涵蓋一般知識問題。這些回應來自訓練於多樣網路文本的 AI 模型所獲得的資訊。',
    contexts: '內容脈絡',
    ai_processing_video_sharebot:
      '影片的 AI 處理將花費約 24 小時，完成後將於 Sharebot 中顯示。',
    remove_sharebot_video: `若您希望移除與 Sharebot 的影片關聯，請一併刪除影片和文字稿。`,
    remove_sharebot_video_audio:
      '刪除文字稿將移除與 Sharebot 的影片/音訊連結，但影片仍會顯示在媒體庫或頻道中。',
    monthly_live_stream: '若要變更每月直播限制，請聯絡我們',
    monthly_transcribe_limit: '若要變更每月轉錄限制，請聯絡我們',
    must_be_one_to_three_hundred: '必須在 1 到 300 分鐘之間。',
    all_field_required: '所有欄位皆為必填。',
    duration_minute: '時長（最多 300 分鐘）',
    gender: '性別',
    select_gender: '選擇性別',
    accent: '口音',
    select_accent: '選擇口音',
    create_voice: '建立語音',
    enter_voice_name: '輸入語音名稱',
    select_voice_gender: '請選擇語音性別',
    upload_voice: '上傳您的語音',
    upload_voice_mp_three: '上傳您的語音 (.mp3)',
    cloned_voice: '已克隆語音',
    voice_type: '語音類型',
    select_voice_type: '選擇語音類型',
    sharelook_stand: '標準版',
    sharelook_premium: '高級版',
    sharelook_custum_voice: '自訂（語音克隆）',
    create_auto_flow: '建立自動流程',
    how_many_layers: '層數',
    verify_selection: '確認選擇',
    uploaded_successful: '上傳成功',
    upload_failed: '上傳失敗',
    upload_only_five_mb: '上傳內容（PDF 檔案，最多 5 份）',
    docs_from_org_library: '使用組織資料庫中的文件',
    failed_maze_generate: '迷宮生成失敗。請重試。',
    generate_metamaze: '正在生成 MetaMaze...',
    metamaze_being_generated:
      '您的 MetaMaze 正在生成中，完成後我們將以電子郵件通知您。',
    metamaze_generate_successfully: 'MetaMaze 生成成功！',
    metamaze_with_proceed: '您現在可以繼續進行 MetaMaze。',
    ai_metamaze_generate: 'AI MetaMaze 生成',
    what_kind_maze_create: '您想要建立什麼類型的迷宮？',
    manual_metamaze_creation: '手動建立 MetaMaze',
    manually_maze_customizing_scnario: '自訂情境與選項樹以手動建立迷宮',
    maze_ai_generated: '使用 AI 自動生成迷宮',
    unmark_deadend: '取消標記為死路',
    mark_deadend: '標記為死路',
    select_multiple_image_for_scenario: '您可以為情境選擇多張圖片。',
    select_your_image: '您選擇的圖片',
    click_to_preview: '點擊預覽',
    are_you_sure_delete_image: '您確定要刪除此圖片嗎？',
    select_image_from_library: '從媒體資料庫中選擇圖片',
    uploading_video: '正在上傳影片...',
    tree_node_type: '樹狀節點類型',
    correct_option_scenario: '正確選項或情境',
    incorrect_option: '錯誤選項',
    option_scenario_without_text: '無文字的選項或情境',
    dead_end: '死路（紅色邊框）',
    correct_path: '正確路徑',
    incorrect_path_not_selected_correct_option_path:
      '錯誤路徑／未選擇正確選項的路徑',
    double_click_on_tree_node:
      '當您雙擊樹節點時，文字編輯器將自動滾動顯示該節點內容。',
    add_scenario: '新增情境',
    add_option: '新增選項',
    an_error_occured: '發生錯誤：',
    download_summary: '下載摘要',
    step_wise_analysis: '分步分析',
    step: '步驟',
    upload_csv_file: '上傳 CSV 檔案',
    download_template_to_import: '下載範本以匯入',
    please_input_email: '請輸入電子郵件。',
    email_at_least_three_characters: '電子郵件至少需包含三個字元。',
    email_cannot_be_empty: '電子郵件不可為空。',
    input_email_in_new_line: '請輸入電子郵件（一行一個）',
    role: '角色',
    select_role: '請選擇角色',
    select_group: '請選擇群組',
    identification_number: '身份識別號碼（選填）',
    add_identification_number: '請新增身份識別號碼',
    pie_chart_of_all_categories: '所有類別在 Sharelook 上使用情況的圓餅圖。',
    total_sharesphere_question_answered_by_users:
      '本組織中用戶回答的 ShareSphere 問題總數，包含各類別的成功與失敗統計。',
    voice_style_over_the_text: `您可以在輸入的文字上使用各種語音風格，Lorem Ipsum 是印刷與排版業的虛擬文字範例，自 1500 年代以來即為業界標準。`,
    input_your_question: '請輸入您的問題！',
    make_me_sales_manager: '例如：我要如何成為銷售經理？',
    enter_the_number_relevant_document: '請輸入相關文件數量',
    please_wait_loading_result: '請稍候，正在載入結果...',
    no_result_found: '找不到結果，請嘗試提出更多問題',
    browser_doesnot_support_iframes: '您的瀏覽器不支援 iframes',
    total_duration: '總時長',
    number_of_messages: '訊息數量',
    search_result: '搜尋結果',
    count_result: '(共 1244 筆結果)',
    your_other_interests: '您的其他興趣',
    your_total_score: '您的總分',
    add_a_question: '+新增問題',
    travia_question_empty: 'Travia 問題清單為空。',
    video_generation_is_on_queue: '您的影片正在排隊生成！',
    checking_video_status: '正在檢查影片狀態...',
    total_quizzes: '測驗總數',
    number_of_votes: '投票數',
    total_events: '活動總數',
    number_of_rates: '評分數量',
    number_of_likes: '喜歡數量',
    all_courses: '所有課程',
    total_questions: '總問題數',
    no_skill_journey: '沒有可用的技能學習路徑！',
    search_no_results: '- 找不到任何結果！',
    no_image_generated: '尚未生成圖片！',
    all_topic_in_this_lesson: '本課程的所有主題將被刪除，此操作無法復原。',
    content_has_been_generated: '已為此主題生成內容。',
    update_course_template: '更新課程範本',
    add_course_template: '新增課程範本',
    create_course_now: '立即建立課程',
    preview_course: '預覽課程',
    layout: '版面配置',
    import_from_youtube: '從 YouTube 匯入',
    my_media_library: '我的媒體庫',
    bg_added: '已新增背景',
    add_bg: '新增背景',
    booked_schedule: '已預約行程',
    add_schedule: '新增行程',
    are_you_delete_schedule: '您確定要刪除此行程嗎？',
    add_task: '新增任務',
    update_calender: '更新行事曆',
    manage_cookies: '管理 Cookie',
    cookie_banner_text:
      '我們使用 Cookie 來提升您的瀏覽體驗、分析網站流量，以及個人化內容。您的隱私對我們很重要。',
    accept_all_cookies: '接受所有 Cookie',
    reject_all: '拒絕全部',
    customize: '自訂',
    cookie_preferences_title: 'Cookie 偏好與隱私設定',
    privacy_subtitle:
      '您的隱私對我們很重要。選擇您願意接受的 Cookie，您可隨時更改這些設定。',
    save_choices: '儲存我的選擇',
    strictly_necessary: '絕對必要',
    strictly_necessary_desc:
      '這些 Cookie 對網站正常運作至關重要，可啟用基本功能，例如頁面導覽、表單提交及安全區域存取。沒有這些 Cookie，網站將無法正常運作。',
    analytics_performance: '分析與效能',
    analytics_performance_desc:
      '這些 Cookie 可幫助我們了解訪客如何互動網站，匿名收集及報告資訊，協助改善網站效能與使用者體驗。',
    advertising_marketing: '廣告與行銷',
    advertising_marketing_desc:
      '這些 Cookie 可使廣告訊息更符合您的需求，避免同一則廣告重複出現，並確保廣告正確展示給廣告主。',
    tracking_social: '追蹤與社群媒體',
    tracking_social_desc:
      '這些 Cookie 可提供增強功能與個人化，例如社群媒體功能與個人化內容，可能由我們或第三方提供。',
    functional: '功能性',
    functional_desc:
      '這些 Cookie 可啟用增強功能，例如聊天支援、即時協助與其他互動功能，以改善您的網站體驗。',
    your_rights: '您的權利：',
    rights_description: '您可隨時撤回同意、存取您的資料，或請求刪除。',
    withdraw_consent: '撤回所有同意',

    how_many_options: '選項數量',
    add_content: '新增內容',
    downloads_center: '下載中心',
    sharelook_help_center: 'Sharelook 幫助中心',
    channel_outline: '頻道大綱',
    channel_objectives: '頻道目標',
    no_sop_available: '無 SOP 列表可用。',
    generate_world_summary: '生成情境',
    world_scenario: '真實世界情境',
    drag_icon_hint: '提示：拖曳圖示至畫布上以調整位置',
    drag_text_hint: '提示：拖曳文字至畫布上以調整位置',
    edit_badge: '編輯徽章',
    create_new_badge: '新增徽章',
    select_video_preview: '選擇影片以預覽',
    certificate_title_required: '證書標題為必填',
    discard_changes: '捨棄變更',
    edit_certificate: '編輯證書',
    add_another_logo: '新增另一個 Logo',
    optional: '選填',
    doc: 'DOC',
    ppt: 'PPT',
    quest_title: '建立新任務',
    quest_filter_title: '任務',
    sharelook_assistance: 'Sharelook 協助',
    upload_scorm_zip: '上傳 SCORM Zip',
    only_letters_numbers_space_dot_allowed: '僅允許字母、數字、空格及句點！',
    video_playing: '播放中',
    course_price_message: '*課程僅對組織內使用者發布，無法在市集販售。',
    lesson_must_be_positive: '課程數量必須大於 1',
    btn_proceed: '繼續',
    rule_select_music: '請選擇音樂',
    course_info: '課程資訊',
    content_selection: '內容選擇',
    course_content_source: '課程內容來源',
    choose_how_to_source: '選擇課程內容來源方式：',
    automatic_selection: '自動選擇',
    system_will_automatically_select_relavant_documents:
      '系統將自動從您的資料庫選擇相關文件',
    manual_selection: '手動選擇',
    choose_specific_documents_from_your_library: '從資料庫中選擇特定文件',
    upload_files: '上傳文件',
    upload_new_documents:
      '上傳新文件 (PDF, DOC, DOCX, PPT, PPTX, TXT) - 最多 5 個文件',
    file: '文件',
    ready_to_upload: '準備上傳',
    clear_all: '清除全部',
    confirm_course_wide_premiew: '確認全課程預覽',
    generate_course_preview: '生成課程預覽',
    instructions_across_the_course_to_generate:
      '我們將在整個課程中套用您的指示以生成預覽。請先檢查所有內容，再決定保留或捨棄變更。',
    instruction_to_preview_course_wide: '全課程預覽指示：',
    edit_content: '編輯內容',
    manage_course_template: '管理課程模板',
    undo: '復原',
    apply_changes: '套用變更',
    characters: '字元',
    apply_all: '套用全部',
    apply_to_all: '套用至所有',
    use_this_content: '使用此內容',
    original: '原始',
    edited: '已編輯',
    edited_content_preview: '已編輯內容預覽',
    apply_edits_to_all_topices: '將編輯套用至所有主題？',
    current_editing_instructions_across_the_whole_course:
      '此操作將在整個課程中套用您目前的編輯指示。您可以在儲存前查看合併預覽。',
    edit_content_instructions: '內容編輯指示',
    generate_content_for_this_topic_instruction: '使用您的指示生成本主題內容',
    descrip_edit_content: '描述如何編輯此內容 (例如，縮短、簡化、改寫)',
    try_short_clear_direcctives:
      '嘗試簡短清楚的指示。例如：“縮減至 100 字，保留重點”，“簡化語言”，“更精簡並刪除贅字”。',
    we_preserve_the_core_meaning: '在套用指示時保留核心意義。',
    feedback_optional: '反饋（可選）',
    write_your_feedback_here: '在此撰寫您的反饋',
    from_web: '來自網頁',
    from_desktop: '來自桌面',
    pleae_wait_processing: '請稍候，處理中…',
    create_simulation_from_screen_capture: '從螢幕截圖建立模擬',
    sharelook_not_found: '找不到 ShareLook',
    sharelook_screen_capture_application_not_be_opened:
      '無法開啟 ShareLook 螢幕截圖應用程式，可能未安裝於您的電腦',
    download_sharelook: '下載 ShareLook',
    launch_sharelook_application: '啟動 ShareLook 應用程式',
    this_will_open_the_sharelook_application_for_screen_capture:
      '這將開啟 ShareLook 應用程式以進行螢幕截圖',
    sharelook_dosenot_open: '若 ShareLook 無法開啟，可能未安裝於您的電腦',
    open_sharelook: '開啟 ShareLook',
    download_app: '下載應用程式',
    background_image_setting: '背景圖設定',
    current_image: '目前圖片',
    change_image: '更換圖片',
    remove_image: '移除圖片',
    no_background_image_selected: '尚未選擇背景圖片',
    add_image: '新增圖片',
    this_will_open_for_screen_recording: '將開啟 ShareLook 以進行螢幕錄製',
    ai_image_generation: 'AI 生成圖片',
    image_edit: '編輯圖片',
    text_to_image: '文字轉圖片',
    output_gallary: '輸出畫廊',
    instant_generation: '即時生成',
    prompt_and_unleash_the_power: '輸入提示並釋放力量',
    use_this_image: '使用此圖片',
    error_generating: '生成時發生錯誤',
    generation_tips: '生成技巧',
    detailed_descriptions_for_more_accurate_results:
      '使用詳細描述以獲得更精準結果',
    reference_image: '參考圖片',
    select_pixel_image: '選擇像素圖片',
    max_mb: '最大 50MB',
    please_enter_text_to_appear_image: '請輸入要出現在圖片的文字',
    enter_text_to_apear_in_the_image: '輸入要出現在圖片的文字',
    generate_image: '生成圖片',
    prompt_assistant: '提示助理',
    generate_image_using_suggested_prompt: '使用建議提示生成圖片',
    talk_to_ai_about_the_image_generate: '與 AI 討論您想生成的圖片',
    ask_for_prompt_suggestions: '請求提示建議...',
    enter_a_search_term_to_find_stock_images: '輸入搜尋詞以尋找素材圖片',
    choose_your_content_source: '選擇您的內容來源：',
    upload_new_document_from_your_device: '從裝置上傳新文件',
    automatic_library_selection: '自動資料庫選擇',
    system_automatically_selects_relevant_document: '系統將自動選擇相關文件',
    manual_library_selection: '手動資料庫選擇',
    generate_content: '生成內容',
    add_to_current_page: '新增至目前頁面',
    generate_bullet_points: '生成重點項目',
    generating: '生成中',
    this_may_take_a_few_moments: '這可能需要一些時間',
    apply_to_page: '套用至頁面',
    scenario_escription: '情境描述：',
    feedback: '回饋',
    form_mode: '表單模式',
    chat_mode: '聊天模式',
    this_will_generate_a_continuation_of_the_seleccted_story:
      '這將使用 AI 生成所選故事的後續內容。',
    continue_this_story_question: '要繼續這個故事嗎？',
    continue_this_story: '繼續此故事',
    what_will_happen: '將會發生：',
    the_ai_will_analyze_the_existing_story_content: 'AI 將分析現有故事內容',
    generate_a_natural_continuation_that_follows_the_same_tone:
      '生成符合相同語氣與風格的自然延續內容',
    create_new_content_that_build_upon_the_current_narrative:
      '創建建立在當前敘事基礎上的新內容',
    this_process_may_take_a_few_moments_to_complete:
      '此過程可能需要一些時間完成。',
    no_existing_stories_found_for_this_course: '此課程尚無現有故事。',
    create_your_first_story: '創建您的第一個故事',
    existing_stories: '現有故事',
    create_new_story: '創建新故事',
    tone: '語氣',
    style: '風格',
    genre: '類型',
    loading_your_stories: '正在加載您的故事...',
    edit_story: '編輯故事',
    story_preferences: '故事偏好',
    please_input_your: '請輸入您的',
    add_character_names_and_press_enter: '添加角色名稱並按 Enter',
    select_or_type_your: '選擇或輸入您的',
    enter_your: '輸入您的',
    position_of_the_story_in_the_lesson:
      '故事在課程中的位置。故事將作為一個區塊添加到指定位置。',
    save_previous_content_on_the_pages: '保存頁面上的先前內容',
    the_existing_content_in_the_selected_pages:
      '選定頁面上的現有內容將被生成的故事替換。',
    real_world_scenario: '真實世界情境',
    add_optional_instructions: '添加可選指示（語氣、長度、受眾等）',
    ready_to_enerate_your_real_world_scenario: '準備生成您的真實世界情境',
    click_generate_real_world_scenario_to_create_a_realistic_scenario:
      '點擊「生成真實世界情境」以基於課程內容創建逼真的情境。',
    the_ai_will_analyze_your_lesson_topic_and_content:
      'AI 將分析您的課程主題與內容',
    generate_a_practical_real_world_scenario: '生成實用的真實世界情境',
    you_can_then_edit_and_customize_the_result: '然後您可以編輯並自訂結果',

    add_it_as_a_new_page_to_your_lesson: '將其作為新頁添加到您的課程',
    regenerate_with_instructions: '根據指示重新生成',
    add_real_world_scenario: '添加真實世界情境',
    generate_real_world_scenario: '生成真實世界情境',
    simulation_has_been_stopped: '模擬已停止！',
    loading_simulation: '正在加載模擬...',
    you_have_exhausted_all_the_attempts: '您已用完所有嘗試',
    study_the_scenario_on_this_page_and_select_the_correct_answer:
      '研究此頁面上的情境並從下方選項中選擇正確答案。',
    attempts_limit_reached:
      '已達嘗試限制。您可以再次遊玩，但您的分數不會被保存。',
    play_again: '再玩一次',
    import_music_from_computer: '從電腦導入音樂。',
    more: '更多',
    no_badge_yet: '尚無徽章',
    competition_filter: '競賽篩選',
    global_leaderboard: '全球排行榜',
    placeholder_for_the_global_leaderboard: '這是全球排行榜的佔位符。',
    badge_editor: '徽章編輯器',
    adjust_the_appearance_of_this_badge_icon:
      '調整此徽章圖示的外觀。更改僅應用於此徽章。',
    badge_style: '徽章樣式',
    the_image_must_be_pixels: '圖片必須為 200x200 像素。',
    badge_name: '徽章名稱',
    badge_descrription: '徽章描述',
    enter_badge_criteria: '輸入徽章標準',
    discard: '放棄',
    badge_enable: '啟用徽章',
    award_users_with_badges_to_highlight_the_milestones:
      '向用戶頒發徽章以突出其學習里程碑。',
    badge_types: '徽章類型',
    enable_or_disable_specific_badge_types_for_your_users:
      '為您的用戶啟用或禁用特定徽章類型。',
    levels_enabled: '啟用等級',
    level_rules: '等級規則',
    points: '點數',
    add_new_level: '新增等級',
    add_level: '添加等級',
    points_enabled: '啟用點數',
    learning_activities_and_encourage_healthy_competition:
      '為不同學習活動授予用戶點數並鼓勵良性競爭。',
    award_points: '授予點數',
    the_following_equates_the_value_of_one_item_completion:
      '以下相當於完成一個項目的價值',
    general: '一般',
    others: '其他',
    certificate: '證書',
    quiz_passed: '測驗通過',
    tip_approved: '提示已批准',
    tip_liked: '提示已點讚',
    rewards: '獎勵',
    offer_discounts_when_learners_achieve:
      '當學習者達到一定點數、徽章或等級時提供折扣。',
    give_rewards: '給予獎勵',
    discount_course_purchases_by: '課程購買折扣',
    with_points_more_than: '點數大於',
    with_badges_more_than: '徽章大於',
    with_level_upwards_more_than: '等級高於',
    leaderboard: '排行榜',
    leaderboard_enabled: '啟用排行榜',
    leaderboards_offer_users_an_overview_of_their_learning_progress:
      '排行榜提供用戶學習進度概覽，與其他人比較點數。',
    show_levels: '顯示等級',
    show_points: '顯示點數',
    show_badges: '顯示徽章',
    show_courses: '顯示課程',
    show_certificates: '顯示證書',
    leaderboard_settings: '排行榜設定',
    set_up_engaging_leaderboard_experiences_to_boost_learner_motivation:
      '設置有趣的排行榜體驗以提升學習者動力。',
    award_users_with_points_for_different_learning_activities:
      '為不同學習活動授予用戶點數。',
    badge_set: '徽章套件',
    choose_the_type_of_badges_your_users:
      '選擇用戶學習過程中將獲得的徽章類型。',
    levels: '等級',
    Levels_represent_the_stages: '等級代表用戶學習旅程中的階段。',
    enabled: '啟用',
    disabled: '禁用',
    quick_select: '快速選擇',
    yesterday: '昨天',
    last_week: '上週',
    Last_month: '上個月',
    last_quarter: '上個季度',
    historical_leaderboard: '歷史排行榜',
    track_your_performance_and_see_how_you_rank_among_your_peers:
      '追蹤您的表現並查看您在同儕中的排名',
    time_period: '時間範圍',
    page_of: '第 1 頁，共 1 頁',
    edit_competition: '編輯競賽',
    create_competition: '創建競賽',
    arrow_right: '右箭頭',
    update_competition: '更新競賽',
    competition_title: '競賽標題',
    enter_competition_title: '輸入競賽標題',
    enter_competition_description: '輸入競賽描述',
    leaderboard_skill: '技能',
    select_a_skill: '選擇技能',
    no_skills_found: '未找到技能',
    competition_period: '競賽期間',
    add_badge_rule: '添加徽章規則',
    create_badge: '創建徽章',
    add_level_rule: '添加等級規則',
    selected_participants: '已選參與者',
    no_participants: '無參與者',
    start_end_date: '開始–結束日期',
    created_date: '建立者',
    new_competition: '新競賽',
    competitions_list: '競賽列表',
    search_competitions: '搜尋競賽...',
    are_you_sure_you_want_to_delete_the_competition: '您確定要刪除此競賽嗎？',
    history: '歷史',
    export: '匯出',
    search_by_name: '按名稱搜尋...',
    no_historical_data_available_for_the_selected_period:
      '所選期間無歷史數據。',
    no_leaderboard_data_available: '無排行榜數據。',
    competitions: '競賽',
    leaderboards: '排行榜',
    welcome_back: '歡迎回來',
    track_your_performance_and_see: '追蹤您的表現並查看排名',
    team_leaderboard: '團隊排行榜',
    try_again: '再試一次',
    no_competitions_for_search: '搜尋無競賽',
    no_competitions_available: '無可用競賽',
    no_competitions_matching_search:
      '未找到符合搜尋的競賽。請調整搜尋條件或稍後再試。',
    no_competitions_general:
      '目前尚無設定任何競賽。請稍後回來或聯絡管理員創建新競賽。',
    media_management: '媒體管理',
    badgess_set: '徽章套件',
    choose_the_default_visual_style_for_badge: '選擇平台使用的徽章圖示預設樣式',
    enable_badges: '啟用徽章',
    add_badge: '新增徽章',
    min: '最小',
    max: '最大',
    your_rank: '您的排名',
    your_points: '您的點數',
    your_level: '您的等級',
    rank: '排名 #',
    level: '等級',
    progress: '進度',
    new_folder: '新資料夾',
    file_upload: '上傳檔案',
    writer: '撰寫者',
    text_documents: '文字文件',
    spreadsheets: '試算表',
    impress: '簡報',
    presentations: '簡報文件',
    capture_desktop_screen: '擷取桌面畫面',
    capture_desktop_screens: '擷取桌面多個畫面',
    your_documents: '您的文件',
    manage_your_videos_images_audio_files:
      '管理您的影片、圖片、音訊檔及其他創作素材',
    your_organization_documents: '您的組織文件',
    keep_your_organization_creative_assets_organized:
      '保持組織的創意素材有序且可存取—精簡團隊合作及內容製作流程',
    your_public_documents: '您的公開文件',
    curated_collection_of_media_assets_available:
      '精選可供所有人使用的媒體素材—探索、重用與創作',
    your_download_center_documents: '您的下載中心文件',
    repository_of_approved_media_assets_for_download:
      '可供下載並使用於專案的核准媒體素材庫',
    search_files_and_folders: '搜尋檔案和資料夾..',
    home: '首頁',
    folders: '資料夾',
    folder_name: '資料夾名稱',
    owner: '擁有者',
    last_updated: '最後更新',
    action: '操作',
    no_folders_found: '找不到資料夾',
    files: '檔案',
    enabling_ai: '啟用 AI...',
    rename: '重新命名',
    copy: '複製',
    move: '移動',
    verson_history: '版本歷史',
    manage_permission: '管理權限',
    generate_audit_report: '生成審核報告',
    last_edited: '最後編輯',
    no_files_found: '找不到檔案',
    are_you_sure_you_want_to_make_this_item_public:
      '您確定要將此項目設為公開嗎？它將被複製到您的公開資料庫。',
    move_to_organization: '移動到組織',
    are_you_sure_you_want_to_copy_this_item_to_your_organization_library:
      '您確定要將此項目複製到您的組織資料庫嗎？',
    are_you_sure_you_want_to_make_this_item_private:
      '您確定要將此項目設為私人嗎？它將被複製到您的個人資料庫。',
    date_modified: '修改日期',
    workflow_management: '工作流程管理',
    configure_editors_approvers_and_viewers_for_this_document:
      '設定此文件的編輯者、核准者與閱覽者',
    error_Loading_editor: '載入編輯器時發生錯誤',
    debug_info: '除錯資訊',
    loading_editor: '正在載入編輯器...',
    submitted_for_review: '已提交審核',
    editors: '編輯者',
    no_editors_added_yet: '尚未新增編輯者。點擊「新增編輯者」來添加。',
    add_editor: '新增編輯者',
    approvers: '核准者',
    no_approvers_added_yet: '尚未新增核准者。點擊「新增核准者」來添加。',
    add_approvers: '新增核准者',
    viewer: '閱覽者',
    no_viewers_added_yet: '尚未新增閱覽者。點擊「新增閱覽者」來添加。',
    add_viewer: '新增閱覽者',
    are_you_sure_you_want_to_delete_the_selected_items:
      '您確定要刪除所選項目嗎？'
  },
  v3: {
    reportShareSphere: '分享球體',
    overview: '社群民調總覽',
    triviaReport: 'ShareSphere 趣味問答',
    overviewGraph: '社群總覽圖表',
    category: '分類',
    phCategory: '選擇分類',
    podcast: 'Podcast、音樂與故事',
    pastPodcast: '過去的 Podcast',
    upcomingPodcast: '即將到來的 Podcast',
    podcastLanguageTitle: 'Podcast、音樂與故事語言',
    podcastLanguageCheckbox: '使用 AI 為我的 Podcast 語言服務',
    howRate: '你如何評價這個 Podcast？',
    podcastSubmit: '提交',
    podcastGuest: '來賓：',
    podcastReview: '評論',
    podcastEpishode: '集數',
    podcastEnd: 'Podcast 已結束',
    date_podcast: 'Podcast 日期',
    skill_not_found: '抱歉！未找到技能旅程',
    coaching: '教練指導',
    webinar: '線上研討會',
    public_conference: '公開會議',
    skill_journey_subtitle: '選擇您的技能，並控制誰可以看到並與您聯繫',
    enable_white_label: '啟用白標',
    create_new_event_org: '為您的組織創建新活動',
    create_new_event_marketplace: '為市集創建新活動',
    create_new_event_both: '為您的組織與市集創建新活動',
    event_outline: '輸入活動概要',
    event_obj: '輸入活動目標',
    event_description: '輸入活動描述',
    create_new_metamaze_org: '為您的組織創建新的 Metamaze',
    create_new_metamaze_marketplace: '為市集創建新的 Metamaze',
    create_new_metamaze_both: '為組織與市集創建新的 Metamaze',
    add_key_words: '添加關鍵字',
    press_enter_make_keyword: '按 Enter 鍵創建關鍵字',
    disable_skip_quiz: '停用跳過測驗',
    warning_complete_quiz: '請完成測驗以繼續',
    signup_email_verification: '驗證連結已發送到您的電子信箱，請點擊以完成註冊',
    verifying_registration: '正在驗證註冊...',
    reset_password_linK:
      '重設密碼的連結已發送到您的電子信箱，請點擊以下載新密碼',
    reset_email_error: '找不到與該電子郵件相關的帳號，請嘗試其他用戶名',
    first_name: '名字',
    last_name: '姓氏',
    error_firstName: '請輸入您的名字',
    error_sharebot_organization: '請輸入組織名稱',
    error_lastName: '請輸入您的姓氏',
    private_conference: '私人會議',
    public_conference: '公開會議',
    discussion_room: '討論室',
    training_no_courses: '您尚未參與任何課程',
    training_no_events: '您尚未參與任何活動',
    allow_sharing_trainer_info: '允許在市集分享教練電子郵件',
    error_username_space: '使用者名稱不能包含空格',
    error_sharebot_organization_space: '組織名稱不能包含空格',
    edit_permission: '編輯權限',
    valid_price: '價格必須大於 0',
    course_price_message: '*此課程僅限組織內部使用，無法在市集上銷售',
    valid_edit_price: '編輯價格必須小於購買價格',
    my_calendar: '我的行事曆',
    error_valid_firstName: '請輸入有效的名字',
    error_valid_organization: '請輸入有效的組織名稱',
    error_valid_lastName: '請輸入有效的姓氏',
    error_name_spaces: '名稱中不能包含空格',
    items: '項目',
    publish_to_channel: '發布到我的頻道',
    create_a_channel: '建立我的頻道',
    create_a_trivia: '建立趣味問答',
    create_a_new_channel: '建立新頻道',
    add_videos: '新增影片',
    save_and_continue: '儲存並繼續',
    channel: '頻道',
    channels: '所有頻道',
    view_channel: '查看頻道',
    edit_channel: '編輯頻道',
    delete_channel: '刪除頻道',
    my_video_channels: '我的影片頻道',
    training_no_channel: '您尚未參與任何頻道',
    monthly_price_required: '必須輸入每月價格',
    yearly_price_required: '必須輸入每年價格',
    one_time_price_required: '必須輸入一次性價格',
    marketplace_quantity: '數量',
    report_webinar: '線上研討會',
    report_coaching: '教練指導',
    report_channel: '頻道',
    report_public_conference: '公開會議',
    report_maze: '迷宮',
    channel: '頻道',
    edit_price: '編輯價格 ($)',
    quantity: '數量',
    payment_type: '付款類型',
    total_amount: '總金額 ($)',
    net_amount: '淨金額 ($)',
    edit_option: '編輯選項',
    marketplace_price: '市集價格 ($)',
    market_name: '名稱',
    duration_min: '時長 (分鐘)',
    users_total: '使用者 (總數)',
    sales_total: '銷售總額 (美元)',
    search_coaching: '搜尋教練指導',
    search_channel: '搜尋頻道',
    search_webinar: '搜尋線上研討會',
    search_maze: '搜尋迷宮',
    search_public_conference: '搜尋公開會議',
    buyer_type: '購買者類型',
    quanity: '數量',
    channel_unit_amount: '淨金額 ($)',
    channel_updated_at: '更新時間',
    month_price: '價格 (每月)',
    year_price: '價格 (每年)',
    one_time_price: '價格 (一次性)',
    sharebot_organization: '輸入您的新組織名稱',
    share_sphere: '分享球體',
    ai_course_title: '課程名稱',
    ai_input_course_title: '請輸入課程名稱！',
    learning_objective_label: '學習目標',
    learning_objective_message: '請輸入學習目標！',
    standard_question: '是否有學生需遵守的標準？',
    standard_details_label: '標準詳情',
    standard_details_message: '請輸入標準詳情！',
    estimated_duration_label: '預估時長（分鐘）',
    estimated_duration_message: '請輸入預估時長！',
    min_duration_message: '最短時長為 5 分鐘',
    ai_mins: '25 分鐘',
    industry_specific_question: '是否與特定產業相關？',
    industry_label: '產業名稱',
    industry_message: '請輸入產業名稱！',
    ai_course_creation: 'AI 建立課程',
    course_generated: 'Sharelook 建立的課程',
    ai: 'AI',
    ai_you: '你',
    ai_prompt_ready: '您的請求已就緒，現在可以產生課程大綱',
    ai_unable_respond: '很抱歉！目前無法回應您的請求，請稍後再試',
    ai_hide_toc: '隱藏課程大綱',
    ai_preview_toc: '預覽課程大綱',
    ai_generate_toc_now: '立即生成大綱',
    ai_creation_course_title: '課程名稱：',
    ai_creation_industry_specific: '是否與產業相關：',
    ai_creation_industry: '產業：',
    ai_creation_standard_needed: '是否需要遵守標準：',
    ai_creation_standard_details: '標準詳情：',
    ai_creation_estimated_duration: '預估時長（分鐘）：',
    minutes: '分鐘',
    ai_creation_learning_objective: '學習目標：',
    setup_again: '重新設置',
    ai_creation_confirm_title: '是否要重新設置？',
    ai_creation_confirm_content: '所有對話與生成的內容將被重設',
    ai_toc: '課程大綱',
    ai_note_topic: '注意：可拖放課程內的主題',
    ai_add_topic: '+ 新增主題',
    add_topic: '新增主題',
    add_lesson: '新增課程單元',
    add_new_lesson: '新增課程單元',
    ai_add_lesson: '+ 新增課程單元',
    attention: '注意',
    before_varifying: '在驗證之前',
    ai_save_later: '稍後儲存',
    ai_download_word_doc: '下載 Word 文件',
    ai_download_course_word_doc: '將課程下載為 Word 文件',
    ai_create_course_button: '建立課程',
    ai_generate_course_content: '生成課程內容',
    ai_out_of: '/',
    ai_subtopic_failed_content:
      '部分子主題無法生成內容，請再次點選「生成課程內容」',
    ai_edit_topic: '編輯主題',
    ai_edit_lesson_title: '編輯課程單元標題',
    ai_save_topic: '儲存主題',
    ai_save: '儲存',
    ai_save_lesson_title: '儲存課程單元標題',
    ai_add_new_topic: '新增主題',
    ai_download_ref: '下載含參考資料',
    ai_download_ref_content: '課程將以包含參考資料的 Word 文件下載',
    ai_download_without_ref: '下載不含參考資料',
    ai_download_two_word: '下載兩份 Word 文件：',
    ai_download_two_word_content_one: '- 一份只含內容（不含參考資料），',
    ai_download_two_word_content_two: '另一份只含參考資料（不含內容）',
    ai_manage_content: '管理內容',
    ai_add_content_from_internet: '+ 從網路新增內容',
    ai_confirm_start: '確認開始',
    ai_Verify: '驗證',
    ai_undo_warning:
      '此操作可能需要一些時間，執行期間請勿關閉此視窗。此操作不可復原。',
    ai_verified_content: '您已驗證內容，AI 對話將無法再使用',
    ai_want_proceed: '您確定要繼續嗎？',
    upload_simulation: '上傳模擬',
    name_simulation: '模擬名稱',
    selected_simulation_files: '已選擇的模擬檔案',
    score_between_one_hundred: '分數需介於 1 至 100 之間',
    are_sure_simulation: '您確定要刪除此模擬檔案嗎？',
    required_simulation: '分數為必填',
    required_section_file: '段落檔案為必填',
    simulation: '模擬',
    simulation_quiz_games: '問題應屬於測驗遊戲',
    simulation_alert_des: '僅當所有問題皆為單選或多選時可新增遊戲',
    alert_info: '資訊',
    ai_number_quiz: '測驗題數',
    ai_point: '分數',
    ai_points: '分數',
    val_required: '必填',
    games: '遊戲',
    add_simulation: '新增模擬',
    text_tiewer: '文字檢視器',
    back_to_account: '返回帳號',
    delete_account: '刪除帳號',
    delete_account_title: '您是否確定要刪除帳號？',
    delete_account_subtitle: '您可以在此刪除帳號',
    delete_account_cannot_undo: '您將刪除帳號，此操作無法復原',
    account_org_profile: '所有帳號、課程及組織資料將被刪除',
    deleting_account_database: '刪除帳號後，所有資料將從系統中移除',
    account_confirm_delete: '您確定要刪除帳號嗎？',
    action_cannot_be_undone: '此操作無法復原',
    account_delete_message_success: '您的帳號已成功刪除',
    message_edit: '編輯',
    message_delete: '刪除',
    message_reply: '回覆',
    attached_file: '附件',
    attach_file: '附加檔案',
    attach_des: '最大 25 MB',
    view: '檢視',
    go_to_marketplace: '前往市集',
    learning_center: '學習中心',
    knowledge_center: '知識中心',
    sharebot: 'ShareBot',
    sharebot_help_message: '今天我可以幫您什麼忙？',
    my_organization: '我的組織',
    world_knowledge: '全球知識',
    welcome_to_sharelook: '歡迎來到 Sharelook！',
    sharelook_you_want_go: '今天您想去哪裡？',
    shareLook_learning_management_system:
      '進入 ShareLook 的學習管理系統以建立與參與企業內的直播活動與課程',
    shareLook_powerful_ai_system:
      '上傳 PDF 文件，透過 ShareLook 強大的 AI 系統快速提取資訊，從企業知識或全球知識中獲得答案',
    edit_now: '立即編輯',
    sharelook_log_out: '您已登出 Sharelook，請重新登入！',
    sorry_error: '很抱歉！發生錯誤',
    login: '登入',
    refresh_page: '重新整理頁面',
    just_a_moment: '請稍候',
    enter_lname_fname: '請輸入您的名字與姓氏以繼續',
    procced_to_sharelook: '前往 Sharelook',
    option_one: '選項一',
    option_two: '選項二',
    selected_image: '已選擇圖片：',
    add_text: '新增文字',
    linkdin_is_required: 'LinkedIn 為必填',
    bio_is_required: '簡介為必填',
    save_user_information: '儲存使用者資訊',
    select_all: '全選',
    enable_ai: '啟用 AI',
    load_more: '載入更多',
    channel_id: '頻道 ID',
    send: '發送',
    v4: '資訊',
    subscription: '訂閱',
    reset_user_flag: '重設使用者標記',
    delete_my_accont: '刪除我的帳號',
    sharebot_sub_error: '獲取訂閱資訊時發生錯誤，請重試！',
    sharebot_no_sub: '尚未訂閱',
    sharebot_dont_sub: '先前未曾訂閱',
    sharebot_prev_sub: '先前的訂閱',
    sharebot_sub: 'ShareBot 訂閱',
    sharebot_un_sub: '取消 ShareBot 訂閱',
    sharebot_no_available: '無可用資料',
    sharebot_start_date: '開始日期：',
    sharebot_end_date: '結束日期：',
    sharebot_sure: '您確定嗎？',
    sharebot_do_you_want: '您想要',
    unsubscribe: '取消訂閱',
    unsubscribe_what: '您是否想取消訂閱？',
    subscribe: '訂閱',
    subscribe_what: '您是否想要訂閱？',
    subscribe_now: '立即訂閱',
    confirm: '確認',
    sharebot_intel_knowledge_center: 'ShareBot 知識中心',
    sharebot_welcome_paragraph:
      '歡迎來到 ShareBot 知識中心，這是您的 AI 助理，旨在協助專業人士快速獲取資訊',
    expired: '已過期',
    active: '啟用中',
    Inactive: '未啟用',
    yearly_subscription: '年度訂閱',
    monthly_subscription: '每月訂閱',
    no_sharebot_org: '您尚未擁有任何 ShareBot 組織',
    sharebot_start_free_trial: '開始免費試用',
    sub_month: '月訂閱',
    sub_year: '年訂閱',
    question_per_month: '資料儲存（1TB）及每月 1000 個提問',
    sharebot_para:
      '繼續此操作即表示您確認立即刪除此組織。此操作將導致 ShareBot 所提供的所有寶貴洞見遺失，且無法復原。',
    cancelled_date: '取消日期：',
    live_straming_para: '若您希望更改每月直播限制，請聯繫',
    sharelook_agree: '我同意 Sharelook 的',
    terms_condition: '條款與細則',
    and: '及',
    privacy_policy: '隱私政策',
    save_for_later: '稍後儲存',
    ai: 'AI',
    no_video_yet: '尚未選擇任何影片！',
    are_you_sure_delete_video: '確定要刪除此影片嗎？',
    video_des: '說明',
    video_now: '現在',
    video_playing: '正在播放：',
    video_no: '影片編號',
    ai_generated_course: 'AI 生成課程',
    create_course_on_our_own: '自行建立課程',
    ai_Assisted_ourse_reation: 'AI 協助課程建立',
    pending: '待處理',
    published: '已發布',
    intro_course: '在您的課程中？',
    clone_course: '是否要複製',
    browser_audio_not_support: '您的瀏覽器不支援 audio 標籤。',
    audio_popup_content:
      '您可以在所輸入的文字上使用多種語音風格。Lorem Ipsum 是印刷與排版業長期使用的佔位文字。',
    close: '關閉',
    podcast_rec: '錄音',
    create_podcast: '建立 Podcast',
    add_admin: '新增管理員',
    delete_all: '全部刪除',
    ai_podcast_audio: 'AI Podcast 音訊',
    language: '語言',
    podcast_download_content: '*下載 AI 生成的音訊檔以便編輯並成為您的音訊檔。',
    upload_audio: '上傳音訊',
    browser_do_not_support_audio: '您的瀏覽器不支援音訊元素。',
    upload_cover: '上傳封面',
    upload_ai_creator: 'AI 創作者',
    required_cover_image: '封面圖片為必填！',
    room_required_name: 'Podcast 名稱為必填！',
    add_guest_list: '請新增來賓名單！',
    podcast_add_participants: '新增參與者',
    topic_required: '至少需有一個主題',
    podcast_description: '描述',
    podcast_date: '日期',
    date: '日期',
    podcast_time: '時間',
    podcast_to: '至',
    podcast_all_day: '整天',
    podcast_start_date_time: '需填寫開始日期與時間！',
    podcast_id: 'ID',
    selected_user: '邀請已選使用者',
    see_more: '顯示更多',
    see_less: '顯示較少',
    no_review_yet: '尚無評論，快來當第一位！',
    request_to_speak: '接受使用者的講話申請？',
    kick_user: '要踢除此使用者嗎？',
    accept_request: '接受申請',
    kick: '踢除',
    started: '已開始',
    end: '結束',
    join_now: '立即加入',
    podcast_end: 'Podcast 已結束',
    connecting: '連線中…',
    knowledge_center_know_today: '今天想了解什麼？',
    knowledge_center_question: '請先輸入問題',
    knowledge_center_error: '抱歉！我們遇到錯誤。',
    knowledge_center_tooltrip:
      '使用組織內 ShareLook 的學習資源，即可快速獲得答案，並提供參考來源與 PDF 文件預覽及下載功能。',
    my_organization: '我的組織',
    world_knowledge: '世界知識',
    open_file: '開啟檔案',
    reference: '參考',
    are_you_cancel: '確定要取消嗎？',
    are_you_remove_media: '確定要移除此媒體嗎？',
    terms_agree: '我同意以下內容',
    ready: '準備就緒',
    send_email: '發送電子郵件',
    active_users: '使用者數（活躍）',
    sign_up_user: '已註冊使用者',
    non_sign_up_user: '未註冊使用者',
    organisation: '組織',
    usage_report: '使用報告',
    check_email: '請檢查您的電子郵件',
    delete_schedule: '刪除行事曆',
    are_you_sure_delete_schedule: '確定要刪除此排程嗎？',
    add_task: '請輸入任務！',
    coaching_available: '標記為可進行教練',
    message_booking_coaching: '此時段已被使用者預訂為教練時間。',
    task_day: '任務日',
    created_task_day: '您已為該日建立任務。',
    event_day: '活動日',
    has_booked_coaching: '該日已有教練預約。',
    active_day: '啟用日',
    selectable_time_slots: '右側可選時段在該日可使用。',
    compare_last_month: '與上個月比較',
    uploading_file: '正在上傳您的檔案',
    attach_file_course: '已附加至此課程。',
    fetch_request: '正在擷取您的請求',
    finilize_upload: '正在完成上傳',
    scorm_scanned: '請稍候…您的 SCORM 檔案正在掃描中。',
    scan_status: '掃描狀態：',
    scan_completed: '掃描完成。您的檔案為',
    scan_progress: '掃描進行中…',
    check_scorm: '正在檢查 SCORM 檔案格式…請稍候…',
    file_check_success: '檔案檢查成功',
    file_check_progress: '檔案檢查進行中…',
    scorm_not_upload: '您上傳的檔案不符合 SCORM 1.2 標準，請重新上傳符合檔案。',
    select_question: '答案選項（請選擇一個正確答案）',
    select_answer: '請選擇答案！',
    check_option_one: '請輸入選項一！',
    check_option_two: '請輸入選項二！',
    check_option_three: '請輸入選項三！',
    check_option_four: '請輸入選項四！',
    question_image: '問題圖片',
    select_question_image: '請選擇問題圖片！',
    ans_image: '答案圖片',
    upload_image_question: '上傳答案圖片',
    select_image_answer: '請選擇答案圖片！',
    save_question: '儲存問題',
    do_you_leave: '確定要離開嗎？',
    loose_all_progress: '您將失去所有進度。',
    welcome: '歡迎',
    team_knowledge_quest: '團隊知識探索',
    your_score: '您的分數',
    start_playing: '開始遊玩',
    share_sphere_complete: 'ShareSphere 已完成',
    final_score: '最終分數',
    play_next: '繼續遊玩',
    you_donot_access_event: '您無法存取此活動。',
    ai_content_generated: '已為此主題生成內容。',
    ai_popup_confirm_content: '確認生成內容',
    limit_transcribe_text:
      '剩餘轉錄時間：<0>{{ transcribe_limit }}</0> 分鐘 <1/><2/> <3>。若要變更您的轉錄限制，請聯絡 </3> <4>admin@sharelook.com</4>。',
    you_donot_access_event: '您無權訪問此活動。',
    ai_course_title_training: '領導力訓練課程',
    ai_course_object: '數位時代的領導力導航',
    create_ai_video: '建立 AI 影片',
    generate: '產生',
    video_generate_process:
      '影片產生過程可能需要一些時間，完成後我們將透過電子郵件通知您。',
    stripe_account_connect:
      '您的 Stripe 帳戶尚未啟用。請連接或啟用以繼續操作。',
    ai_creator: 'AI 創作工具',
    check_video_status: '正在檢查影片產生狀態...',
    video_on_queue: '影片正在排隊處理中。',
    video_fail_generation: '很抱歉，影片產生失敗。請嘗試其他影片。',
    video_currently_generated: '此影片目前正在產生中。',
    checking_status: '正在檢查狀態',
    check_status: '檢查狀態',
    browser_does_not_support_audio: '您的瀏覽器不支援 audio 標籤',
    existing_edit_scenario:
      '您想要編輯現有情境還是建立新情境？如果建立新的，舊情境將會遺失。',
    generate_scenario: '產生情境',
    layout: '版面配置',
    confirm_change: '確認變更',
    generated_ai_creation_message:
      '請注意，僅保留由 AI 產生的文字元素，其餘元素將從頁面中移除。',
    generate_story: '產生故事',
    save_original_content: '保留原始內容：',
    story_added_specified_position:
      '故事在課程中的位置。故事將以區塊形式新增至指定位置。',
    position_of_story: '故事位置',
    start_the_lesson: '課程開始',
    end_the_lesson: '課程結束',
    add_story_pages: '將故事加入頁面',
    browser_does_not_support: '您的瀏覽器不支援音訊元件。',
    no_video_available: '目前沒有可用的影片。',
    no_podcast_available: '目前沒有可用的播客。',
    no_item_baskets: '購物籃中沒有項目。',
    ai_course_object: '數位時代的領導力導航'
  },
  v2: {
    n_data: '無資料',
    change: '更改',
    remove: '移除',
    auto_background: '自動背景',
    create_new_course_org: '為您的組織建立新課程。',
    create_new_course_marketplace: '為市場建立新課程。',
    create_new_course_both: '為您的組織和市場同時建立新課程。',
    ok: '確定',
    page_bg: '頁面背景',
    lesson_cover: '課程封面圖片',
    create_skill_journey: '建立技能旅程',
    Metamaze: 'Metamaze',
    events: '活動',
    scroms: 'SCORMs',
    min_score_pass: '最低通過分數',
    no_scorms_available: '目前沒有可用的SCORM。',
    no_events_available: '目前沒有可用的活動。',
    no_courses_available: '目前沒有可用的課程。',
    no_courses_baskets: '購物籃中沒有課程。',
    no_mazes_baskets: '購物籃中沒有迷宮。',
    no_scroms_baskets: '購物籃中沒有SCORMs。',
    no_events_baskets: '購物籃中沒有活動。',
    sorry: '抱歉！',
    option_1: '選項 1',
    option_2: '選項 2',
    enter_number_words: '輸入最大字數。',
    summarize: '摘要',
    answer: '回答',
    hold_tight_one_minute: '請稍等！我們仍在準備中，這可能需要一分鐘。',
    enter_question: '輸入您的問題。',
    enter_relevant_documents: '輸入相關文件數量。',
    please_input_relevant_documents: '請輸入相關文件數量！',
    please_wait_loading_results: '請稍候，正在載入結果…',
    proceed_to_add_voice: '繼續新增語音',
    results: '結果',
    no_result_found_try_asking_questions: '未找到結果。請嘗試問更多問題。',
    eg: '例如，',
    what_make_sales_manager: '什麼能讓我成為銷售經理？',
    please_select_lang: '請選擇任意語言！',
    search: '搜尋',
    please_copy_desired_content: '請將左側方框中所需內容複製到右側方框。',
    rating_req: '評分為必填欄位。',
    review_req: '評論為必填欄位。',
    rating_review_req: '必須同時提供評分與評論。',
    how_rate_this: '您會如何評價這個？',
    amazing_above_expectations: '驚人！超出預期！',
    certificates: '證書',
    you_no_certificates: '您目前沒有可用的證書。',
    please_add_review: '請提供評論和評分，謝謝！',
    post: '發佈',
    rate: '評分',
    avg_rating: '平均評分',
    no_review_found: '找不到評論',
    are_sure_to_disale_zoom_integration: '您確定要停用Zoom整合嗎？',
    badges: '徽章',
    you_no_badge_available: '您目前沒有可用的徽章。',
    download_certificate: '下載證書',
    loading: '載入中...',
    no_file_attached: '沒有附加檔案',
    you_do_not_have_any_notes: '您沒有任何筆記。',
    question: '問題',
    score: '分數',
    alert_score_message: '有人已提交分數。',
    alert_question_message: '目前尚未新增問題。',
    button_submit: '提交',
    button_allScores: '所有分數皆已提交。',
    record_wait: '錄音開始中，請稍候...',
    buttonSubmit_warning: '請在提交前輸入所有分數。',
    upload_ar_assets: '上傳 AR 資產',
    edit_ar_assets: '編輯 AR 資產',
    edit_maze_assets: '編輯 MetaMaze 資產',
    upload_assets: '上傳資產',
    upload_maze_assets: '上傳 MetaMaze 資產',
    trigger_title: '觸發器標題',
    model_title: '模型標題',
    trigger_description: '觸發器描述',
    model_description: '模型描述',
    please_type_target_description: '請輸入目標描述。',
    please_type_model_description: '請輸入模型描述。',
    trigger_image: '觸發器圖片*',
    model_image: '模型圖片*',
    upload_trigger_image: '上傳觸發器圖片',
    upload_model_image: '上傳模型圖片',
    drag_n_drop: '拖放',
    file_size_should_not_exceed: '(圖片檔案 (JPEG) 大小不可超過 512 KB)',
    zip_size_should_not_exceed: '(壓縮檔大小不可超過 60 MB)',
    ar_content: 'AR 內容*',
    model_content: '3D 模型*',
    upload_3d_zip: '上傳 ZIP / 影片',
    upload_3d_maze_zip: '上傳 ZIP',
    audio_content: '音訊內容',
    _mp3: '(.mp3)',
    content_attached: '已附加壓縮檔。',
    video_attached: '已附加影片。',
    audio_attached: '已附加音訊。',
    enter_trigger_image_title: '輸入觸發器圖片標題。',
    enter_model_title: '輸入 MetaMaze 模型標題。',
    ar_preview_image: 'AR 預覽圖片',
    upload_preview_image: '上傳預覽圖片',
    upload_audio: '上傳音訊',
    creating___: '建立中...',
    updating___: '更新中...',
    create: '建立',
    update: '更新',
    ar_assets: '3D 圖片',
    _3d_files_mp4: '(壓縮的 .obj、.fbx 或 .mp4 影片)',
    _3d_files_mp4_ar: '(壓縮的 .obj、.fbx)',
    maze_3d_files_mp4: '(壓縮的 .obj、.fbx)',
    _jpg_files: '僅支援 .jpg',
    persons_have_submitted_their_scores: '已有人提交了他們的分數。',
    no_questions_added_till_now: '尚未新增任何問題。',
    submit: '提交',
    all_scores_submitted: '所有分數均已提交。',
    recording_is_starting: '錄製即將開始，請稍候...',
    please_input_scores_before_submitting: '請在提交前輸入所有分數。',
    end_for_all: '結束所有人',
    full_screen: '全螢幕',
    breakout_room: '分組討論室',
    send_invitations: '發送邀請',
    add_participants: '新增參與者',
    create_breakout_room: '建立分組討論室',
    connecting: '連接中...',
    currently_broadcaster_unavailable: '目前主持人無法使用。',
    how_many_breakout_room_to_create: '您想建立多少個分組討論室？',
    create_upto_three_breakout_rooms: '*最多可建立 3 個分組討論室',
    allow: '允許',
    additional: '額外',
    attachment: '附件',
    no_description_available: '無可用描述。',
    people: '人員',
    waiting: '等待中',
    hand_raising_users: '舉手用戶',
    invite: '邀請',
    create_room: '建立房間',
    create_live_event: '建立直播活動',
    support_upto_fivethousand_participants: '支援高達 5,000 名參與者的活動',
    support_upto_ten_participants: '支援最多 10 名直播影片參與者',
    support_upto_twohundred_participants: '支援高達 200 名參與者的活動',
    supprt_upto_five_participants: '支援最多 5 名直播影片參與者',
    support_upto_twentyfive_participants: '支援最多 25 名直播影片參與者的活動',
    two_live_video_participants:
      '活動中有 2 名直播影片參與者（主持人與參與者）',
    you_can_have_upto_five_examinees: '您最多可有 5 名考生。',
    you_can_have_upto_twentyfive_participants: '您最多可有 25 名參與者。',
    you_can_have_upto_five_participants: '您最多可有 5 名參與者。',
    you_can_have_upto_ten_participants: '您最多可有 10 名參與者。',
    select_hosts_email: '選擇主持人電子郵件',
    send_invite_email: '發送邀請電子郵件',
    do_not_send_invite_email: '不發送邀請電子郵件',
    error: '錯誤',
    max_twentyfive_users_allowed: '最多允許選擇 25 名使用者',
    max_five_users_allowed: '最多允許選擇 5 名使用者',
    max_ten_users_allowed: '最多允許選擇 10 名使用者',
    no_user_found: '找不到使用者',
    transcribe_to: '轉錄至',
    integrate_zoom_to_start_meeting: '將 Zoom 整合到您的帳戶以開始 Zoom 會議。',
    zoom_is_not_integrated: '尚未整合 Zoom。',
    delete_poll: '刪除投票',
    add_poll: '新增投票',
    live_now: '正在直播！',
    average_rating: '平均評分',
    review: '評論',
    time_spent: '花費時間',
    total: '總計',
    mins: '分鐘',
    no_data: '此測驗沒有資料。',
    total_score: '總分',
    pass_score: '及格分數',
    point: '分數',
    wrong: '錯誤',
    response: '回應',
    submitted: '已提交',
    average: '平均',
    total_play: '總播放次數',
    view_graph: '查看圖表',
    time_spent_mins: '花費時間（分鐘）',
    play: '播放',
    ideal_path: '理想路徑',
    user_incorrect_path: '用戶錯誤路徑',
    ideal_path_taken: '用戶採取的理想路徑',
    scenario: '情境',
    option: '選項',
    spend: '花費',
    average_spending_time: '平均花費時間',
    activity_overview: '活動概述',
    live_event: '直播活動',
    live_assessment: '直播評估',
    report_download: '報告下載',
    all_workshops: '所有工作坊',
    overview_average_activity: '活動平均概覽',
    overview_workshop_graph: '工作坊概覽圖表',
    mazes: '迷宮',
    correct_feedback: '正確回饋',
    incorrect_feedback: '錯誤回饋',
    checkin_checkout: '簽到 - 簽退',
    minutes: '分鐘',
    incorrect_path: '錯誤路徑',
    answer_not_available: '答案不可用',
    views: '觀看次數',
    item: '項目',
    questions: '問題',
    total_points: '總分數',
    total_attempts: '總嘗試次數',
    created_date: '建立日期',
    host_name: '主持人名稱',
    host_section: '主持人區段',
    choose_products: '選擇產品',
    add_to_basket: '加入購物籃',
    basket: '購物籃',
    times: '次數',
    scorms: 'SCORMs',
    skill_journey_overview: '技能旅程概覽',
    how_to_use: '使用說明',
    live_broadcast_description: '我們將直播視頻整合到易於使用的課程建構器中',
    live_broadcast_subdescription:
      '透過ShareLook專利的直播系統，您可以創造互動、實現學習自動化，並最大化知識共享。',
    disclaimer: `我保證我的技能旅程不會：
  - 侵害任何第三方權利
  - 包含任何非法內容，包括誹謗、猥褻、不雅、下流、色情、暴力、辱罵、侮辱、威脅或歧視性內容，即使使用星號隱藏
  - 包含對其他人的人身攻擊
  - 冒充其他參與者、公共人物或名人
  - 在未經個人同意下包含任何錄音或個人資料，並且不違反任何地區的資料保護規範
  - 包含任何商業招攬或任何形式的「垃圾郵件」`,
    price: '價格',
    video_link: '視頻連結',
    category: '分類',
    objectives: '目標',
    marketplace_description: '市場說明',

    live_discussion: '直播討論',
    poll: '投票',
    hide_grid: '隱藏網格',
    show_grid: '顯示網格',
    stop_screen_share: '停止共享螢幕',
    screen_share: '共享螢幕',
    mute: '靜音',
    unmute: '取消靜音',
    raise_hand: '舉手',
    waiting__: '等待中...',
    audio_active: '音訊啟用'
  },
  general: {
    save: '儲存',
    autosaved: '已自動儲存',
    back_to: '返回到',
    by: '由',
    chat: '聊天',
    completed: '已完成',
    canceled: '已取消',
    component: '成分',
    confirm: '確定',
    course: '課程',
    skill: '技能之旅',
    maze: '元迷宮',
    channel: '頻道',
    podcast: '播客',

    date: '日期',
    details: '詳情',
    empty: '沒有數據',
    enrolled: '已注册',
    free: '免費',
    graph: '圖表',
    loading: '裝載中...',
    lesson: '課堂',
    lessons: '課堂',
    live_assessment: '現場直播評估',
    live_event: '現場直播活動',
    no: '否',
    of: '的',
    or: '或',
    organization: '組織',
    page: '頁面',
    pages: '頁面',
    personal: '個人',
    poll: '民意調查',
    rating: '評分',
    reset: '重設',
    signin: '登入',
    signup: '注冊',
    soon: '不久',
    type: '種類',
    uploading: '上載中...',
    yes: '是',
    something_went_wrong: '某些事出錯了!',
    view_all: '查看所有',
    upload_successful: '上載成功',
    upload_successful_message:
      '你的excel 表格文件已被成功上載和現在處理中。這可能需要一些時間。',
    check_email_upload_successful:
      '請 <0>檢查你的電郵</0> 來取得 <1>報告</1> 中的已上載用戶清單',
    is_private: '私人'
  },

  account: {
    title: '帳戶',
    subtitle: '管理你的設定和帳戶資料',
    saved: '帳戶已成功更改'
  },

  assessments: {
    title: '評估',
    subtitle: '創造一個評估',
    finished: '這評估已完成',
    countdown: '現場直播評估將會廣播於Live assessment will be broadcasting in ',
    create: '創造評估',
    list_title: '你的評估',
    delete_warning: '你確認想要刪除這項目？',
    details_title: '添加評估詳情',
    details_subtitle: '給你的評估名字和說給你的觀眾他們能期望由此學到什麼',
    disclaimer: `我保證我已記錄的評估將不會：
-違犯任何第三方的權利
-包含任何違法行為，包括誹謗，猥褻，不雅，淫蕩，色情，暴力，濫用，侮辱，威脅，或歧視內容，甚至偽裝成星號
-包含任何人身攻擊在其他人上
-包含任何冒充其他參加者，公眾人物或名人
-未經該指定人同意前包含任何人的任何記錄或個人資訊和不會違反世界各地的任何數據保護法規 
(This sentence has without the consent of such individual put at the front)
-包含任何商業招標或各種不當訊息`,
    assessment_details: '評估詳情',

    assessment_settings: '評估設定'
  },

  buildersettings: {
    title: '發佈設定',
    subtitle: '添加設定到你的活動，誰可觀看和與你的活動互動'
  },

  buttons: {
    market_place: 'Market Place',
    back_to_normal: 'Back To Normal',
    add: '添加',
    add_page: '添加頁面',
    add_lesson: '添加課堂',
    add_answer: '添加新答案',
    add_group: '添加群組',
    add_organization: '添加組織',
    add_question: '添加問題',
    add_quiz: '添加測驗',
    add_users: '添加用戶',
    back: '返回',
    back_to_course: '返回到課程概要',
    back_to_lesson: '返回到課堂概要',
    back_to_media: '返回到媒體圖書館',
    back_to_details: '返回到詳情',
    cancel: '取消',
    clear: '清除',
    close: '關閉',
    clone: '複製',
    close_lesson: '關閉課堂',
    clone_course: '複製課程',
    confirm: '確認',
    create: '創造',
    download: '下載',
    download_mass_user_tamplate: '下載樣板',
    add_mass_users: '添加大量用戶',
    upload_excel_list: '上載excel表格清單',
    delete: '刪除媒體',
    edit: '編輯',
    edit_course: '編輯課程',
    enroll: '註冊',
    finish: '完成',
    upload_image: '上載圖片',
    upload_image_video: '上載圖片或視頻',
    select_media_library: '選擇媒體圖書館',
    make_public: '設成公開',
    make_private: '設成私人',
    make_org: '設成組織',
    media: '媒體圖書館',
    my_theme: '我的主題',
    next: '下一個',
    next_lesson: '下一個課堂',
    next_step: '下一步',
    previous_step: '上一步',
    publish: '發佈',
    publish_assessment: '發佈你的評估',
    publish_course: '發佈你的課程',
    publish_event: '發佈你的活動',
    reset: '重設',
    reset_elements: '重設元件',
    save: '儲存',
    creating: '創造中...',
    updating: '上載中...',
    saved: '已儲存',
    save_for_later: '儲存留下來後用',
    save_settings: '儲存設定',
    select_files: '選擇文件',
    select_theme: '選擇主題',
    start_lesson: '開始課堂',
    update: '更新',
    upload: '上載',
    upload_audio: '上載音訊',
    upload_photo: '上載個人資料圖片',
    upload_video: '上載視頻',
    enrolled: '已注冊',
    unenroll: '取消註冊',
    from_library: '媒體圖書館',
    remove: '清除',
    removed: '已清除',
    start_broadcast: '開始廣播',
    end_broadcast: '完結廣播',
    camera: '相機',
    screen: '屏幕',
    screen_with_camera: '有相機的屏幕',
    insert: '插入',

    inserting: '插入中'
  },

  card: {
    quick_add: '快速添加',
    add: '添加',
    clone: '複製',
    completed: '課堂已完成'
  },

  course: {
    upcoming_course: '即將來臨的課程',
    unPublishEvent: '未發佈的活動',
    unPublishAssessment: '未發佈的評估',
    pastCourse: '訓練課程',
    upcoming: '即將來臨的現場直播活動',
    pastEvent: '過去的現場直播活動',
    pastAssessment: '過去的現場直播評估',
    upcomingAssessment: '即將來臨的現場直播評估',
    created: '創造日期：',
    assignees: '受託人',
    organisations: ' {{ 組織 }} 組織 , <2> {{ 用戶 }} 用戶</2>',
    event_date: '現場直播活動日期 <1> {{ 日期 }} </1>',
    delete_warning: '你確認想要刪除這個',
    clonning_no_lesson: '請添加最少一個課堂來復製這個課程',
    clone_warning: '你確認你想要複製這個',
    clone_success: '正在處理複製中 ',
    disclaimer: `我保證我的課程不會：
-違犯任何第三方的權利
-包含任何違法行為，包括誹謗，猥褻，不雅，淫蕩，色情，暴力，濫用，侮辱，威脅，或歧視內容，甚至偽裝成星號
-包含任何人身攻擊在其他人上
-包含任何冒充其他參加者，公眾人物或名人
-未經該指定人同意前包含任何人的任何記錄或個人資訊和不會違反世界各地的任何數據保護法規 
(This sentence has without the consent of such individual put at the front)
-包含任何商業招標或各種不當訊息`
  },

  coursecreate: {
    dropzone_text: '插入媒體',
    sidebar_text: '選擇一個主題 <1/>給你的 <3/>課堂',
    delete_warning: '你確認你想要刪除這課堂？'
  },

  coursepage: {
    quizview_loading: '檢查答案中。請稍候...',
    quizview_answer: '你的答案'
  },

  coursequiz: {
    title: '所有課堂的測驗'
  },

  dashboard: {
    tooltip_title: '不要再顯示這個視頻',
    page_title: '你的課程統計',
    page_subtitle: '你創造的課程狀態',
    profile_add_info: '添加你的 <1>{{未完成文字}}</1> 來完成你的個人資料',
    profile_build: '建立你的個人資料 <1>here</1>, 給我們知道你的興趣和技能',
    profile_title: 'Profile Strength 個人資料強度',
    more_details: '更多詳情'
  },

  errors: {
    answer: '請輸入答案 ',
    answer_correct: '選擇正確的答案',
    code: '請輸入你的驗證碼',
    criterion: '請輸入標準 ',
    duration: '時間長短是需要的 ',
    element: 'Please input element 請輸入元件',
    email: '請輸入你的電郵',
    email_invalid: '輸入的電郵無效',
    feedback_correct: '請輸入正確的反饋 ',
    feedback_incorrect: '請輸入不正確的反饋',
    host: '請輸入活動主持人',
    host_assessment: '請輸入評估主持人',
    image: '請上載一張圖片',
    location: '請輸入你的所在地 ',
    live_location: '請選擇一個廣播地點',
    limit: '請輸入現場直播分鐘',
    min_3char: '3 characters minimum 最少三個字',
    number: '請輸入正數 ',
    host_email_require: `主持人的電郵是需要的`,
    attendee_email_require: `參加者的電郵是需要的`,
    name: '請輸入你的名稱',
    not_found_course: '找不到課程',
    not_found_event: '找不到活動',
    not_found_assessment: '找不到評估',
    password: '請輸入你的密碼',
    password_digit: '最少一個數字',
    password_short: '密碼太短，最少十個字母',
    password_special: '最少一個特殊符號',
    password_uppercase: '最少一個大階字母',
    password_lowercase: '最少一個小階字母',
    phone: '請輸入你的電話',
    phone_invalid: '電話號碼無效',
    position: '請輸入你的職位',
    question: '請輸入問題',
    start_date: '開始日期和時間是需要的',
    tag: '請選擇一個標籤',
    topics: '請選擇最少一個題目',
    live_topics: '請添加題目',
    title: '請輸入標題',
    title_assessment: '請輸入評估標題',
    title_course: '請輸入課程標題',
    title_empty: '標題不能是空的',
    title_event: '請輸入活動標題',
    title_lesson: '請輸入課堂標題',
    title_quiz: '請輸入測驗名稱',
    username: '請輸入你的用戶名字 ',
    upload_error: '錯誤 – 文件不兼容！',
    upload_more_than_10: '你只可以一次上載十個文件',
    topics_max: '請添加最多三個題目',
    upload_excel: '請確認你已上載正確的文件',
    title_excel: '錯誤上載樣板：',
    file_size_exceed: '文件大小超過',
    subtitle_excel: '請確認你使用已提供的樣板和已正確地填寫各欄',
    select_broadcast_option: '請選擇一個選項來廣播這個活動 ',
    multi_hosts_number_error: '演講者人數不能超過已在這活動指定的',
    conference_people_number_error: '參加者人數不能超過已在這活動指定的',
    select_max_host: '為你的活動選擇最少一個演講者',
    select_max_conference: '為你的活動選擇最少一個參加者',
    stream_stop_error: '流播已意外地停止！ ',
    unsecure_context:
      '致命錯誤：瀏覽器不能存取相機和麥克風因為不安全的環境。請安裝SSL安全套接層並使用https超文本傳輸安全協定存取',
    ws_not_supported: '致命錯誤：網絡傳輸協定不支援在這個瀏覽器',

    no_org: '選擇最少一個組織來繼續',
    no_org_group: '選擇最少一個組織群組來繼續.',
    waiting_to_join: '等待某人加入！'
  },

  events: {
    title: '添加現場直播活動詳情',
    change_host: '改變主持人',
    finished: '這活動已完成 ',
    countdown: '現場直播活動將會廣播於',
    subtitle: '給你的現場直播活動名稱和說給你的觀眾他們能期望由此學到什麼',
    poll_disabled: '民意調查不適用於這活動',
    disclaimer: `我保證我已記錄的活動不會：
  -違犯任何第三方的權利
  -包含任何違法行為，包括誹謗，猥褻，不雅，淫蕩，色情，暴力，濫用，侮辱，威脅，或歧視內容，甚至偽裝成星號
  -包含任何人身攻擊在其他人上
  -包含任何冒充其他參加者，公眾人物或名人
  -未經該指定人同意前包含任何人的任何記錄或個人資訊和不會違反世界各地的任何數據保護法規
  -包含任何商業招標或各種不當訊息'`,
    prompt_message: '離開這個頁面將會完成你的活動，你確認要離開這個頁面？',
    duration_exceed_message: '你的廣播超時，這程式會停止廣播',
    before_schedule_message:
      '你將會於這活動預定時間前開始這廣播，請注意停止這廣播將會結束這活動',
    browser_unsupportive_message:
      '你的瀏覽器不支援屏幕分享。你可以看到支援的瀏覽器在這鏈結',
    cancel_switch_host_message: '主持人沒有空。這活動將會由你的終端上繼續',
    coaching_prompt_message: '你不能離開這頁面直至這活動完成為止',
    event_modal_warn: '你想要離開這個活動？',
    confirm_message: '你的活動將會完結如果你點擊好',
    screen_share_denied: '你已拒絕去分享你的屏幕',
    media_not_found: '相機或麥克風不能被找到或你的裝置不允許',
    media_not_access: '相機或麥克風正在被其他流程使用所以你的裝置不允許閱讀',
    constraint_error:
      '這裡沒有已找到的設備可適合你的視頻和音訊限制。你可以改變視頻和音訊的限制',
    media_access_denied: '你不允許去存取相機和麥克風'
  },

  filters: {
    days7: '上七天',
    days15: '上十五天',
    days30: '上三十天',
    days365: '上三百六十五天',
    date: '日期已創造',
    relevance: '關聯',
    popularity: '普及',
    name: '名稱',
    group: '群組',
    Newest_to_Oldest: '最新至最舊',
    Oldest_to_Newest: '最舊至最新',
    A_Z: 'A to Z',
    Z_A: 'Z to A'
  },

  helpers: {
    password:
      '為確保你的帳戶安全我們需要最少一個小階字母，數字在你的密碼裏。你也需要最少有十個字母的長度',
    phone: '請包含你的電話國家代碼，例如：+65 ',
    username:
      '你的用戶名字會當成公開資訊和會有需要時分享給其他用戶。所以，我們建議你不要使用個人資料在你的用戶名字上',

    public_description_normal:
      '你的 <0><0/></0>已被儲存和默認當作為私人。這意指只有你可以看到這內容。要發佈這內容你可以選擇以下其中一個選項。公開發佈你的課程意指它將會供應 （I changed available into provide – the red highlight, as available doesn’t make sense in Chinese. Change it back to 有空 if you wish to stick with available）給這平台上的所有用戶。那指定用戶選項 使你能去分享你的課程給已聯系到分享看帳戶的電郵地址的指定用戶。',

    public_description_admin:
      '這個 <0><0/></0> 已被儲存和默認當作為私人。這意指只有你（和內容創造者）可以看到這內容。 要發佈這內容你可以選擇以下其中一個選項。公開發佈你的課程意指它將會供應 （changed available into provide. Replace with有空 if you want to stick with available）給這平台上的所有用戶 - 包括不在你組織裏的用戶）發佈它到這組織 意指這組織內的所有用戶將會能看到它。你也可以發佈它到一個或多個群組，意指只有在這些群組裏的用戶才能看見它。最後，你有個選項去發佈它給指定用戶的分享看帳戶電郵地址，不管指定用戶是否包括在你的組織裏。'
  },

  labels: {
    add: '添加',
    portrait: 'Crop Portrait',
    landscape: 'Crop Landscape',
    answer_type: '答案類型',
    answers: '答案',
    back_to_quiz: '返回到測驗清單',
    back_to_question: '返回到問題清單',
    chat: '聊天',
    chat_available: '聊天功能不可用該這活動',
    chat_report: '聊天報告',
    choice_single: '單一選擇',
    choice_multiple: '多項選擇',
    choice_free: '「自由」選擇 ',
    choice_sorting: '「排序」選擇',
    choice_matrix: '「矩陣排序」選擇',
    clone_lesson_permission: '複製准許',
    code: '驗證碼',
    correct: '正確',
    created: '日期已創造',
    clone_modal: '複製課程',
    cloning_course: '複製課程中…',
    cloning: '複製中… ',
    cloning_course_desc: '這過程將會需要一些時間。 請耐心等候',
    cloning_success: '課程 "<0/>" 已經被複製成功！',
    description: '簡介',
    disclaimer: '免責聲明',
    drop_file: '放下文件在這裡…',
    duration: '時間長短',
    edit: '編輯 ',
    email: '電郵',
    event: '活動',
    event_all: '所有他的活動',
    event_date: '現場直播活動的當地日期/時間',
    event_this: '這個活動',
    expire: '過期在',
    expiry_date: '過期日',
    forgot: '忘記密碼？',
    group: '群組',
    groups_list: '群組清單',
    host: '主持人',
    id_annotation: '注釋身份',
    id_quiz: '測驗身份',
    incorrect: '不正確',
    interests: '興趣',
    invited: '已邀請',
    live_chat: '現場討論',
    live_stream_limit: '現場直播分鐘',
    contact_text: '要改變你的每月現場直播限制請聯絡 ',
    contact_admin:
      '<0>如你想要改變你的每月現場直播限制請聯絡</0> <1>admin@sharelook.com</1>',
    limit_stream_text:
      '剩餘的現場直播分鐘：<0>{{ 限制 }}</0>分鐘<1/><2/> <3>要改變你的每月現場直播限制請聯絡</3> <4>admin@sharelook.com</4>',
    location: '所在地',
    lessons: '課堂',
    location_broadcast: '主持人服務器所在地 ',
    location_broadcast_subtitle:
      '添加一個最近廣播主持人地點的位置來减少視聽延遲',
    media_manager: '媒體管理員',
    minutes: '分鐘',
    name: '名字',
    online_quiz: '線上測驗',
    organiser: '作者',
    organization: '組織',
    overall_emotion: '整體經驗：',
    organizations_list: '組織清單',
    password: '密碼',
    participants: '參加者',
    picture: '相片（十六比九） ',
    phone: '電話',
    photo: '圖片',
    poll: 'Poll 民意調查',
    position: 'Position 職位',
    processing: 'Processing 處理中',
    privacy_settings: 'Privacy Settings 私人設定',
    question: 'Question 問題',
    quiz_create: 'Create New Quiz 創造新測驗',
    quiz_name: 'Quiz Name 測驗名稱',
    quiz_update: 'Update quiz 更新測驗',
    select_organization: 'Select an organization 選擇一個組織',
    settings: 'Settings 設定',
    show: 'Show 顯示',
    show_graph: 'Show graph result 顯示圖形結果',
    signin: 'Sign In 登入',
    signup: 'Sign Up 註冊',
    sort_by: 'Sort by排序方法 ',
    start_date: 'Start date 開始日期',
    tags: 'Tags 標籤',
    terms: '我同意這些 <1> 條款及細則 </1>.',
    title: 'Title 標題',
    topics: 'Topics 題目',
    topic: 'Topic 題目',
    total_comments: 'Total Comments 總共意見',
    username: 'Username 用戶名字',
    users_list: 'List of Users 用戶清單',
    users_emails: 'Insert specific users emails 插入指定用戶電郵',
    description_specifiction_email:
      '請在各行輸入一個電郵地址來把我分享到多個指定用戶',
    message_specific_email: '請輸入一個指定用戶的電郵',
    viewers: '觀眾',
    edit_course: '編輯',
    edit_assessment: '編輯',
    edit_event: '編輯',
    delete_course: '刪除',
    delete_event: '刪除',
    delete_assessment: '刪除',
    view_course: '觀看',
    view_event: '觀看',
    view_assessment: '觀看',
    date_event: '現場直播活動日期',
    date_assessment: '現場直播評估日期',
    clone_of: '複製',
    clone_course:
      'Create a clone of this course that you can modify independently of the original, includes all lessons and pages. ',
    make: '制造',
    available_to: '提供(available changed into provide)給所有分享看用戶',
    uploaded_by: '上載者： ',
    course: '課程',
    assessment: '評估',
    user_not_exist: '用戶不存在，你想要送出一個邀請？',
    check_user: '通知',
    user_not_exist_in_org: '用戶不存在這組織內，你想要送出一個邀請？',
    title_modal_stream: '改變組織現場直播限制 ',
    des_warning_stream: '你將會改變 ',
    monthly_stream: '每月的現場直播限制：',
    min_per_month: '分鐘/月份',
    broadcast_label: '我想要做：',
    hosts_emails: `插入指定主持人的電郵`,
    attendee_emails: `插入指定參加者的電郵`,
    description_host_specifiction_email: '請在各行輸入一個電郵',
    presenter_label: '主持人',
    presenter_label_conference: '人數',
    event_privacy: '會議模式'
  },

  broadcastOptions: {
    stream_from_phone: '在我的手機上作現場廣播',
    other_webrtc: '由我的電腦上作線上研討會',
    multihost: '由我的電腦上作多播線上研討會',
    peer2peer: '輔導課程',
    conference: '現場直播會議'
  },

  lessoncreate: {
    title: '添加課堂詳情',
    subtitle: '給你的課堂名稱和說給你的觀眾他們能期望由此學到什麼',
    input_label_title: '課堂標題',
    input_label_topics: '課堂題目',
    input_label_description: '課堂簡介',
    delete_warning: '你確定你想要刪除這個頁面？'
  },

  lessonoverview: {
    title: '添加課堂',
    subtitle: '添加現有課堂或創造一個新的',
    new_lesson: '創造一個新的課堂',
    new_lesson_sub: '由零開始創造一個全新課堂！',
    existing_lesson: '選擇現有課堂',
    existing_lesson_sub:
      '連接到一個現存的課堂，這課堂所作的改變將也會影響到該課堂在其他的課程裏',
    clone_lesson: '複製現存課堂',
    clone_lesson_sub:
      '為在這課程裏的課堂制造一個獨特副本，這課堂所作的改變將不會影響到這課堂的正本',
    clone_lesson_modal_sub:
      '請點擊課堂下方的複製按鍵來把你想要的添加到你的課程裏'
  },

  management: {
    groups_title: '管理群組',
    delete_warning: '你確認？',
    organizations_title: '我的組織',
    organizations_subtitle: '添加組織到你的清單',
    users_title: '管理用戶',
    users_position: '高級帳戶管理員',
    user_not_found: '找不到用戶',
    select_org: '請找和選擇一個組織來管理用戶'
  },

  audio: {
    modal_title: '插入音訊',
    list_view: '列表顯示',
    create_audio_modal_title: '創造音訊',
    edit_audio_modal_title: '編輯音訊',
    public_audio_not_found: '找不到音訊',
    private_audio_not_found: '您還沒有上傳任何音訊',
    are_you_sure_to_delete: '您確認想要刪除？',
    type_something: '輸入一些東西',
    select_voice: '選擇',
    file_name: '文件名字',
    description: '簡介',
    topic: '題目',
    key_words_tag: '關鍵字標籤',
    mp3_audio: 'MP3音訊',
    created: '已創造',
    duration: '時間長短',
    close: '關閉'
  },

  image: {
    modal_title: '插入圖片',
    image: '圖片',
    pixel: '像素',
    dimension: '尺寸',
    public_image_not_found: '找不到圖片',
    private_image_not_found: '你還沒有上載任何圖片'
  },

  annotation: {
    modal_title: '注釋'
  },

  text: {
    modal_title: '文字編輯器'
  },

  video: {
    modal_title: '插入視頻',
    image: '視頻',
    mp4_video: 'MP4視頻 ',
    public_video_not_found: '找不到視頻 ',
    private_video_not_found: '你還沒有上載任何視頻'
  },

  media: {
    title: '媒體圖書館',
    subtitle: '你的文件圖書館',
    modal_title: '上載媒體',
    delete_warning: '確認刪除',
    delete_message: '已刪除的媒體將仍然會出現在使用過它們的頁面上',
    dropzone_text: '或拖動和放下',
    delete_success: '媒體已經被成功刪除 ',
    upload_file: '上載文件',
    drag_drop: '或拖動和放下',
    import_file: '由你的電腦中導入文件',
    no_media: '你還沒有上載任何媒體',
    media_type: '媒體類型',
    video: '視頻',
    image: '圖片',
    audio: '音訊',
    gif: 'GIF',
    transcribed_text: 'Transcribed Text',
    media_not_found: '找不到媒體 ',
    of: '的',
    disclaimer: `我保證我的媒體不會：
-違犯任何第三方的權利
-包含任何違法行為，包括誹謗，猥褻，不雅，淫蕩，色情，暴力，濫用，侮辱，威脅，或歧視內容，甚至偽裝成星號
-包含任何人身攻擊在其他人上
-包含任何冒充其他參加者，公眾人物或名人
-未經該指定人同意前包含任何人的任何記錄或個人資訊和不會違反世界各地的任何數據保護法規 
(This sentence has without the consent of such individual put at the front)
-包含任何商業招標或各種不當訊息`,
    my_media: '我的媒體',
    public_library: '公共圖書館',
    organization_library: '組織圖書館',
    upload_from_computer: '由電腦上載',
    create: '創造',
    all: '所有',
    male: '男性',
    female: '女性',
    processing_audio: '處理音訊中',
    create_annotation: '創造注釋',
    popup_over_lesson_text: '註釋將會於點擊後在課堂頁面上彈出',
    edit_detail: '編輯詳情',
    delete: '刪除',
    go_create_audio: '去創造音訊',
    show_more_details: '顯示更多詳情',
    show_less_details: '顯示較少詳情',
    drop_files: '放下文件和哪裡去上載',
    or: '或',
    import_files: '由電腦輸入文件'
  },

  navigation: {
    account: '帳戶',
    assessments: '評估',
    dashboard: '儀表板',
    groups: '群組管理',
    logout: '登出',
    organisations: '組織',
    organizations_users: '組織和用戶',
    reports: '報告',
    schedule: '時間表',
    training: '訓練',
    users: '用戶',
    nowLive: '現在播放',
    workshop: '我的工作坊'
  },

  onboarding: {
    step1_title: '第一步：說給我們一些關於你的某些事',
    step1_subtitle: '你叫什麼名字？ 你從哪裡來？ 你的職位是什麼？',
    step2_title: '第二步：選擇一些技能你能改善的',
    step2_subtitle:
      '然後，告訴我們你有什麼想明白更多。 可能是一些事你還沒學過的？一個新的學習領域？你的愛人做什麼的？'
  },

  pagebuilder: {
    title: '創造課堂',
    subtitle:
      '是時候創造內容給你的觀眾從你學習，你可以添加相片，視頻和信息圖表',
    select_layout: '選擇一個頁面設計',
    template1: '空白',
    template2: '標題和字幕',
    template3: '標題和文字',
    template4: '標題，媒體和文字',
    template5: '標題和媒體',
    template6: '標題和測驗'
  },

  pageconstructor: {
    title: '創造和複製課堂',
    subtitle: '是時候創造內容給你的觀眾從你學習，你可以添加相片，視頻和信息圖表'
  },

  passwordreset: {
    success_coded:
      '我們已寄出一個驗證碼到你提供的電郵地址，請複製該驗證碼到下面這欄來設定一個新密碼 ',
    success_changed: '你已成功設定一個新密碼。你可以現在登入'
  },

  placeholders: {
    search: '搜尋',
    answer: '答案',
    chat: '說些話…',
    code: '驗證碼',
    criterion: '標準',
    date_event: '選擇日期和時間',
    date_start: '開始日期',
    date_expire: '過期日',
    description: '簡介',
    elements: '分類元件',
    email: '電郵',
    feedback_correct: '反饋正確 ',
    feedback_incorrect: '反饋不正確',
    host: '主持人',
    keywords: '搜尋（多個）關鍵字',
    lesson_description: '課堂簡介',
    location: '所在地',
    minutes: '分鐘',
    name: '名稱',
    organiser: '作者',
    organization: '組織',
    password: '密碼',
    phone: '電話',
    photo: '圖片',
    picture: '相片',
    point: '點',
    position: '職位',
    question: '問題',
    quiz: '測驗名稱',
    search_course: '使用課程搜尋',
    search_media: '搜尋媒體',
    search_name: '使用名字搜尋',
    search_title: '使用標題搜尋',
    search_training: '搜尋訓練',
    settings: '設定',
    tags: '標籤',
    title: '標題',
    topics: '題目',
    username: '用戶名字',
    keyword: '關鍵字',
    max_500_characters: '最多五百個字',
    no_description: '這個文件沒有簡介',
    no_keyword: '這個文件沒有關鍵詞 ',
    no_topics: '這個文件沒有一個題目集',
    feedback: '信息',
    contact: '我們可以怎樣幫忙？'
  },

  publishsettings: {
    title: '發佈設定',
    event_subtitle: '添加設定到你的活動，誰能觀看和與你的活動互動',
    assessment_subtitile:
      '給你的評估名稱和說給你的觀眾他們應該期望由此學到什麼',
    course_subtitle: '添加設定到你的課程，誰能觀看和與你的課程互動',
    disclaimer: `1.	注冊

  你在注冊為用戶/創造帳戶時你同意我們的[用戶協議]和確認閱讀了我們的[隱私權政策]

  2.	創造課程

  你在創造課程內容和使用我們的工具時，你同意我們的[用戶協議]和確認閱讀了我們的[隱私權政策]

  3.	創造活動

  你在創造活動和使用我們的工具時，你同意我們的[用戶協議]和確認閱讀了我們的[隱私權政策]

  4.	創造評估

  你在創造評估和使用我們的工具時，你同意我們的[用戶協議]和確認閱讀了我們的[隱私權政策]`,
    dates_validation_error: '兩個日期都應該要填寫',
    emails_validation_error: '電郵清單無效',
    specific_email_validation_error: '只允許一個電郵',
    i_agree_to_these: '我同意這些',
    terms_and_conditions: '條款及細則',
    PublicDescription:
      '免費獨立用戶: （私人和公共選項）你的［課程｜活動｜評估］已被儲存和默認當作為私人。這意指只有你可以看到這內容。要發布這內容你可以在下面選擇將它公開。這意指這課程將會供應 （changed available into provide. Replace with有空 if you want to stick with available）給這平台上的所有用戶。',

    OrganisationsDescription:
      '組織用戶：（使用「發佈」來代替「完成」和把它們帶到與其他用戶相同，但沒有任何發佈選項的發佈頁面上。）你的［課程｜活動｜評估］已被儲存和默認當作為私人。 這意指只有你和你的組織管理員能看到它。作為用戶，你不能在你的組織裏自我發佈你的內容因為這需要管理員權限。請和你的管理員聯絡和問他們來公開發佈你的內容，到整個組織，到指定用戶或組織內的指定群組。',

    OrganisationGroupsDescription:
      '組織管理員：（用於組織內製作的內容：私人，公開，組織，群組，指定用戶）：這［課程｜活動｜評估］已被儲存和默認當作為私人。這意指只有你（和內容創造者）可以看到這內容。要發佈這內容你可以選擇以下其中一個選項。公開發佈你的課程意指這課程將會供應 給這平台上的所有用戶 - 包括不在你組織裏的用戶）發佈它到這組織意指這組織內的所有用戶將會能看到它。你也可以發佈它到一個或多個群組，意指只有在這些群組裏的用戶才能看見它。最後，你有個選項去發佈它給已聯系到分享看帳戶的電郵地址的指定用戶，不管指定用戶是否包括在你的組織裏。',

    SpecificUsersDescription:
      '已付費獨立用戶：（私人，公共和指定用戶）你的［課程｜活動｜評估］已被儲存和默認當作為私人。這意指只有你可以看到這內容。要發佈這內容你可以選擇以下其中一個選項。發佈你的課程到公開意它將會供應(changed available into provide. Replace with有空 if you want to stick with available)給這平台上的所有用戶。那指定用戶選項 使你能去分享你的課程給已聯系到分享看帳戶的電郵地址的指定用戶。'
  },

  quiz: {
    quiz_empty: '你還沒有創造一個測驗',
    questions_empty: '你還沒有創造一條問題'
  },

  regions: {
    asia_pacific_australia: '澳大利亞',
    asia_pacific_india: '印度',
    asia_pacific_japan: '日本',
    asia_pacific_s_korea: '南韓',
    asia_pacific_singapore: '新加坡',
    asia_pacific_taiwan: '臺灣',
    eu_belgium: '比利時',
    eu_germany: '德國',
    eu_ireland: '愛爾蘭',
    south_america_brazil: '巴西',
    us_central_iowa: '愛荷華州',
    us_east_s_carolina: '南北卡羅來納州',
    us_east_virginia: '維珍尼亞州',
    us_west_california: '加州',
    us_west_oregon: '俄勒岡州'
  },

  reports: {
    title: '報告',
    workshop_report: '工作坊報告',
    user_report: '用戶報告',
    organization_workshop: '組織工作坊',
    course: '課程',
    live_event: '現場直播活動',
    workShop_graph: '工作坊圖表',
    organization_account: '組織帳戶',
    all: '所有',
    name: '名稱',
    id_number: '身份號碼',
    email: '電郵',
    search_user_report: '搜尋用戶報告',
    participant: '參加者',
    participants: '參加者',
    host: '主持人',
    username: '用戶名字',
    event: '活動',
    quiz: '測驗',
    assessment: '評估',
    time: '時間',
    no_recent_activity: '沒有最近活動',
    workshops: '工作坊',
    courses: '課程',
    live_events: '現場直播活動',
    live_assessments: '現場直播評估',
    quizzes: '測驗',
    overview: '總體',
    by: '由',
    views: '觀眾數量',
    status: '狀態',
    poll: '民意調查',
    comment: '評論',
    comments: '評論',
    no_comments: '沒有評論',
    no_polls: '沒有民意調查',
    live_date: '現場直播日期',
    score: '得分',
    question: '問題',
    submit: '提交',
    recent_activity: '最近活動',
    ago: '前',
    no_data_found: '找不到數據',
    start_end_live: '開始 / 完結現場直播',
    join_leave_date: '加入 / 離開',
    watched_time: '已觀看時間',
    complete: '完成',
    in_complete: '未完成',
    today: '今天',
    seven_days: '七天',
    last_month: '上個月',
    one_year: '一年',
    all_time: '所有時間',
    report: '報告',
    from_date: '由日期',
    to_date: '到日期',
    all_workshop: '所有工作坊',
    all_participants: '所有參加者',
    live_assessment: '現場直播評估',
    users: '用戶',
    download: '下載',
    recent: '最近',
    WorkShop: '工作坊',
    Activity: '活動',
    created_date: '創造日期',
    lessons: '課堂',
    lesson: '課堂',
    completed: '已完成',
    report_download: '報告下載',
    this_month: '這個月',
    search_course: '搜尋課程',
    participants_graph: '參加者圖表',
    viewed: '已觀看',
    enrolled: '已註冊',
    description: '簡介',
    topic: '題目',
    analytic: '分析',
    quiz_list: '測驗清單',
    select_one: '選擇一個',
    group_status: '群組狀態',
    duration_min: '時間長短(分鐘)',
    submit_poll: '提交民意調查',
    download_events: '下載活動',
    search_event: '搜尋活動',
    duration: '時間長短',
    total_participants: '參加者總計',
    message: '信息',
    avg_message: '一般信息',
    per_message: '信息/活動的百分比'
  },

  signup: {
    success_step1:
      '我們已發送一個驗證碼到你提供的電子郵件，請複製這驗證碼到下面該欄來確認你的註冊',
    success_step2: '謝謝，你已成功注冊',
    privacy: `我同意分享看的 <1> 條款及細則 </1> 和 <3> 隱私權政策 </3>`
  },

  stream: {
    emotion_impressive: '印象深刻的',
    emotion_unimpressive: '普通的',
    message_not_started: '即將來臨',
    message_running: '現場直播',
    message_processing:
      '我們正在處理現場直播記錄中來作回播。請等待回來去查看這視頻和繼續添加評分和反饋'
  },

  tabs: {
    audience: '觀眾',
    course: '課程概要',
    details: '現場直播活動詳情',
    description: '簡介',
    host: '主持人',
    lesson: '課堂概要',
    lessons: '課堂',
    overview: '概要',
    page: '頁面建設工具',
    publish: '發佈 ',
    settings: '發佈設定',
    total_views: '總觀看數字',
    live_participates: '現場直播參加者',
    live_chats: '現場直播聊天',
    live_quiz: '現場直播民意調查',
    trainer_rating: '訓練者評分',
    trainer_times: '訓練者時間',
    courses_quizzes: '課程測驗',
    user_list: '用戶清單',
    discussion: '討論',
    notes: '我的筆記'
  },

  topics: {
    SALES_TRAINING: '銷售訓練',
    NEGOTIATION_TRAINING: '談判訓練',
    CROSS_CULTURAL_AWARENESS: '「跨文化」意識',
    NETWORKING_SKILLS: '社交技能',
    SOFTWARE_ARCHITECTURE: '軟件架構',
    PROJECT_MANAGEMENT: '項目管理',
    DIGITAL_TRANSFORMATION: '數碼轉型',
    IT_CONSULTING: '技術諮詢',
    MANAGEMENT_CONSULTING: '管理諮詢',
    HR_CONSULTING: '人力資源諮詢',
    INTERNET_OF_THINGS: '物聯網',
    CYBERSECURITY: '網絡安全',
    PRIVACY_AND_GDRP: '隱私權和〈一般數據保護條例〉'
  },

  training: {
    title: '訓練',
    title_assessment: '評估',
    subtitle: '課程和現場直播活動',
    enrolled_title: '己註冊的課程和現場直播活動',
    enrolled_subtitle: '你己註冊到的課程和現場直播活動',
    enrolled_message: '你現在沒有註冊到任何課程和活動',
    past_live_event_title: '過去的現場直播活動',
    past_live_event_subTitle: '已完成的現場直播活動',
    past_live_event: '這裡現在沒有過去的現場直播活動',
    recomended_title: '推薦的課程和現場直播活動',
    now_live_event_title: '現在現場直播',
    now_live_event_subTitle: '已開始或將會開始的活動',
    now_live_event: '這裡現在沒有現場直播活動',
    webinar_event_title: '線上研討會頻道',
    webinar_event_subTitle: '已完成的線上研討會',
    webinar_event: '這裡現在沒有線上研討會',
    p2p_event_title: '輔導課程',
    p2p_event_subTitle: '已完成的輔導課程',
    p2p_event: '這裡現在沒有輔導課程',

    now_live_assessment_title: '現在現場直播',
    now_live_assessment_subTitle: '已開始或將會開始的評估',
    now_live_assessment_message: '這裡現在沒有現場直播評估',

    upcoming_assessment_title: '即將來臨的現場直播評估',
    upcoming_assessment_subtitle: '即將來臨的現場直播評估',
    upcoming_assessment_message: '這裡現在沒有即將來臨的現場直播評估',

    past_live_assessment_title: '過去的現場直播評估',
    past_live_assessment_subTitle: '已完成的現場直播評估',
    past_live_assessment_message: '這裡現在沒有過去的現場直播評估',

    /**
     * <0/> get index 0 of data from Trans component
     * exp -->
     * <Trans i18nKey='training:recomended_subtitle' >
     *    <Navlink>{...something}</Navlink> --> is index 0 of Trans component
     *    <h1>{...something}</h1> --> is index 1 of Trans component
     * </Trans>
     */
    recomended_subtitle: '我們有精選課程和現場直播活動  根據你的 <0><0/></0>',
    /**
     * and we also can get data from index to replace in recommended_subtitle by like above string.
     * for exp -->
     * at the end of the recomended_subtitle above will get data from index of component to display
     * <0><0/></0> mean get data index 0 of Trans component above = <Navlink> and <0/> get data index 0 from <Navlink> = {...something}
     */
    search: '搜尋訓練',
    search_assessment: '搜尋評估',
    recomended_message: '這裡現在沒有推薦的課程和活動'
  },

  warnings: {
    delete: '你確定？'
  },

  workshop: {
    title: '我的工作坊',
    subtitle: '創造一個課程或主持一個你的現場直播活動 ',
    new_course: '創造一個新課程',
    new_event: '創造一個新現場直播活動',
    new_assessment: '創造一個新現場直播評估',
    courses_title: '已創造的課程和現場直播活動',
    courses_subtitle:
      'Edit & Publish your created course and plan live events 編輯和發佈你已創造的課程和已計劃的現場直播活動',
    tags_course: '課程',
    tags_live: '現場直播活動',
    tags_assessment: '現場直播評估'
  },

  help_center: {
    sidebar: {
      title: '我們能怎樣幫你？',
      back_to: '儀表板'
    },
    menu: {
      help_center: '幫助中心',
      whats_new: '什麼是新的',
      feedback: '反饋',
      feedback_title: '發送反饋給分享看',
      terms_and_conditions: '條款及細則',
      privacy_policy: '隱私權政策',
      contact_us: '聯繫我們'
    },
    get_started: {
      title: '開始使用分享看',
      description: {
        main: '我們把現場直播視頻集成到容易使用的課程建設工具',
        tagline:
          '使用分享看的現場廣播系統專利權，你能夠創造吸引的課程，自動化學習，和最大化知識分享'
      }
    },
    whats_new: {
      title: '開始使用分享看',
      description: {
        main:
          '你知道要創造融入說故事的學習風格課程只需要短時間，而又不會太昂貴嗎？你應該結合分享看的課程建設工具和所需的人才。你可以問我們「如何」',
        tagline: ''
      }
    },
    create_workshop: '怎樣去創造一個工作坊',
    create_course: '怎樣去創造一個課程',
    create_user: '怎樣去創造一個用戶',
    create_group: '怎樣去創造一個群組',
    create_webinar: '怎樣去創造線上研討會',
    create_live_event: '怎樣去創造現場直播活動',
    create_live_assessment: '怎樣去創造現場直播評估',
    create_live_on_mobile: '在手機上創造現場直播',
    personalize_profile: '個人化個人資料',
    manage_group: '管理群組',
    report: '報告',
    add_annotations: '怎樣去添加注釋/彈出式視窗',
    add_audio: '怎樣去添加音訊',
    add_header_and_footer: '添加頁眉和頁腳 ',
    add_image: '怎樣去添加圖片',
    add_quiz_content: '怎樣去添加測驗內容',
    add_text_content: '怎樣去添加文字內容',
    add_user: '怎樣去添加用戶',
    add_video: '怎樣去添加視頻',
    clone_course: '怎樣去複製課程',
    find_live_broadcast: '怎樣找現場廣播',
    contact_us: {
      title: '聯繫我們',
      subject_placeholder: '輸入主題*',
      content_placeholder: '輸入信息*',
      subject_required: '*主題是需要的',
      content_required: '*信息是需要的',
      submit: '發送',
      cancel: '取消',
      sent: '已發送'
    },
    feedback: {
      title: '送出反饋給分享看',
      attach_title: '附上一個文件',
      choose: '選擇文件',
      detail: '文件將會分享給支持團隊',
      content_placeholder: '打入信息*',
      content_required: '*信息是需要的',
      submit: '發送',
      cancel: '取消',
      sent: '已發送'
    }
  },
  discussion: {
    join_discussion: '加入討論'
  },
  notes: {
    title: '我的筆記',
    add_note: '添加新筆記'
  }
}
